// cspell:disable
// Use backticks instead of quotes to avoid having to escape apostrophes and quotes in the strings
/* oxlint quotes: ["error", "backtick"] */
export const Strings = {
    ACCOUNT: ``,
    ACCOUNT_PROFILE: `Kontoprofil`,
    ACCOUNT_CREATED: ``,
    ACCOUNT_VERIFIED: ``,
    LOG_IN_TO_START_ORDERING: ``,
    VERIFY_LINK_INVALID: ``,
    VERIFY_LINK_INVALID_LOG_IN: ``,
    ORDERS: ``,
    PROFILE: ``,
    PROFILE_UPDATED: ``,
    PAYMENT_METHODS: ``,
    PERSONAL_DETAILS: ``,
    SAVE_CHANGES: ``,
    ADD_CARD: ``,
    CARD_NICKNAME: ``,
    NO_SAVED_CARDS: ``,
    QR_CODE: ``,
    REFRESH_QR_CODE: ``,
    QR_CODE_SCAN_TO_PAY: ``,
    ADA_TOGGLE_ON: `Tippen, um reduzierte Bildschirmhöhe zu aktivieren`,
    ADA_TOGGLE_OFF: `Tippen, um reduzierte Bildschirmhöhe zu deaktivieren`,
    ADD: `Hinzufügen`,
    ADD_DONATION: `Spende hinzufügen`,
    ADD_FUNDS: `Guthaben aufladen`,
    ADD_TIP: `Trinkgeld hinzufügen`,
    ADD_TO_FAVORITES_WEB: ``,
    ADD_TO_ORDER: `Zur Bestellung hinzufügen`,
    ADD_NEW: `Neu hinzufügen`,
    ADDED: `Hinzugefügt`,
    ADDED_TO_FAVORITES_WEB: ``,
    ADDED_TO_ORDER: `Zur Bestellung hinzugefügt`,
    ADDON_TEXTFIELD_PLACEHOLDER: `Geben Sie Ihre Wahl ein.`,
    ADDRESS_CITY: `Stadt`,
    ADDRESS_LINE_1: `Adresse`,
    ADDRESS_LINE_2: `Wohnung, Etage, Suite, Gebäude, Unternehmen (Optional)`,
    ADDRESS_POSTAL_CODE: `Postleitzahl`,
    ALCOHOL_VERIFICATION: `Alkohol-Verifizierung`,
    ALREADY_HAVE_AN_ACCOUNT: ``,
    ALSO_CONSIDER: `Das könnte Ihnen auch gefallen...`,
    APPLIED_STORED_VALUE_CARDS: `Geschenkkarten`,
    ASAP: `So schnell wie möglich`,
    AT_LEAST_X: `mindestens {{$1: number}}`,
    BACK: `Zurück`,
    BACK_TO_MENU: `Zurück zum Menü`,
    BACK_TO_MENU_FROM_LOYALTY: `Zurück zum Menü`,
    BACK_TO_CART: `Zurück zum Warenkorb`,
    BACK_TO_PAYMENT_OPTIONS: `Zurück zu den Zahlungsoptionen`,
    BACK_TO_PAYMENT_OPTIONS_FROM_LOYALTY: `Zurück zu den Zahlungsoptionen`,
    BAD_ACCESS_CODE: `Falscher Zugangscode`,
    BALANCE: `Guthaben`,
    BAG_OPT_IN_PROMPT: `Möchten Sie eine Tragetasche zu Ihrer Bestellung hinzufügen?`,
    BAG_OPT_IN_TITLE: `Tasche hinzufügen?`,
    BAG_OPT_IN: `Ja, ich möchte eine Tasche`,
    BAG_OPT_OUT: `Nein, danke`,
    BLOCKED_WORD_WARNING: `Bitte entfernen Sie die gesperrten Wörter`,
    CALORIES: `Kalorien`,
    CANCEL: `Abbrechen`,
    CANCEL_CHECKOUT: `Abbrechen`,
    CASH: `Kasse`,
    CARD_ENTRY_APM: `APM`,
    CARD_ENTRY_APPLE_PAY: `Apple Pay`,
    CARD_ENTRY_CARD_ON_FILE: `Gespeicherte Karte`,
    CARD_ENTRY_CHIP: `EMV`,
    CARD_ENTRY_CONTACTLESS: `Kontaktlos`,
    CARD_ENTRY_GOOGLE_PAY: `Google Pay`,
    CARD_ENTRY_MANUALLY_ENTERED: `Manuell eingegeben`,
    CARD_ENTRY_PROVIDED_EXTERNALLY: `Extern bereitgestellt`,
    CARD_ENTRY_SCAN: `Scannen`,
    CARD_ENTRY_SWIPE: `Karte durchziehen`,
    CARD_ENTRY_UNKNOWN: `Unbekannt`,
    CARD_EXPIRED: `Karte abgelaufen`,
    CARD_EXPIRING: `Ihre Karte läuft bald ab`,
    CARD_ENDING_IN: ``,
    CARD_EXPIRES_ON: ``,
    CARD_EXPIRES_THIS_MONTH: ``,
    CARD_EXPIRED_LABEL: ``,
    REMOVE_SAVED_CARD_DESCRIPTION: ``,
    CARD_RENAMED: ``,
    REMOVE_SAVED_CARD: ``,
    REMOVE_SAVED_CARD_TITLE: ``,
    RENAME_CARD: ``,
    SHOW_QR_CODE: ``,
    CART: `Warenkorb`,
    CART_LABEL: `Zum Warenkorb mit {{$1: number}} Artikeln für {{$2: price}}`,
    CART_TITLE: ``,
    CHANGE_ITEM: `Artikel ändern`,
    CHANGE_PASSWORD: `Passwort ändern`,
    CHANGE_PASSWORD_SUCCESS: `Ihr Passwort wurde aktualisiert.`,
    CHARS_LEFT: `{{$1: number}} Zeichen übrig`,
    CHECK_AMOUNT: `Betrag wird überprüft...`,
    CHECKOUT: `Bezahlen`,
    CHECKOUT_STEP_CART: `Warenkorb`,
    CHECKOUT_STEP_PAYMENT_OPTIONS: `Zahlung`,
    CHECKOUT_STEP_PAYING: `Zahlung läuft`,
    CHECKOUT_STEP_DONE: `Fertig`,
    CHECKOUT_WITH_FORCED_MENU: `Kann nicht bezahlt werden, während eine Menüvorschau angezeigt wird. Die Zahlung ist nur im Menü „Aktuell angezeigt“ verfügbar.`,
    CHECK_YOUR_EMAIL: ``,
    CHOOSE_OPTION: `Option wählen`,
    CHOOSE_TIME_SLOT: `Bitte wählen Sie einen Zeitslot:`,
    CLEAR_ALL: `Alles löschen`,
    CLEARING_SESSION: `Kiosk wird für den nächsten Kunden vorbereitet...`,
    CLOSE: `Schließen`,
    CLOSED_SCREEN_MESSAGE: `Leider sind wir geschlossen oder nehmen keine mobilen Bestellungen an.`,
    CONFIRM: `Bestätigen`,
    CONFIRM_ADDRESS: `Adresse bestätigen`,
    CONFIRM_DISCARD: `Artikel verwerfen?`,
    CONFIRM_DISCARD_CHANGES: `Möchten Sie Ihre Änderungen wirklich verwerfen?`,
    CONFIRM_YOUR_ITEM: `Artikel bestätigen`,
    CONFIRM_QUIT: `Möchten Sie wirklich beenden?`,
    CONFIRM_REFUND_AMOUNT: `Möchten Sie {{$1: dollar amount}} aus dieser Transaktion erstatten?`,
    CONFIRMING_YOUR_CARD: `Karte wird bestätigt...`,
    CONTINUE: `Weiter`,
    CONTINUE_AS_GUEST: `Als Gast fortfahren`,
    COULD_WE_INTEREST: `Das könnte Sie interessieren...`,
    COMP_CARD: `Kompensationskarte`,
    COMP_CARD_SCAN: `Kompensationskarte scannen`,
    COMP_CARD_SCAN_FAILED_TITLE: `Scan der Kompensationskarte fehlgeschlagen`,
    COMP_CARD_SCAN_FAILED_MESSAGE: `Beim Scannen der Kompensationskarte ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.`,
    COMP_CARD_APPLYING_TITLE: `Kompensationskarte wird angewendet`,
    COMP_CARD_APPLYING_ERROR_TITLE: `Fehler beim Anwenden der Kompensationskarte`,
    COMP_CARD_APPLYING_ERROR_MESSAGE: `Beim Anwenden der Kompensationskarte ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.`,
    COMP_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `Bitte geben Sie eine Kompensationskartennummer ein`,
    COMP_CARD_ENTERING_NUMBER_ERROR_INVALID: `Bitte geben Sie eine gültige Kompensationskartennummer ein`,
    COMP_CARD_ENTERING_NUMBER_ERROR_LENGTH: `Bitte geben Sie eine gültige Kompensationskartennummer ein`,
    COMP_CARD_ENTERING_PIN_ERROR_REQUIRED: `Bitte geben Sie eine Kompensationskarten-PIN ein`,
    COMP_CARD_ENTERING_PIN_ERROR_INVALID: `Bitte geben Sie eine gültige Kompensationskarten-PIN ein`,
    COMP_CARD_ENTERING_PIN_ERROR_LENGTH: `Bitte geben Sie eine gültige Kompensationskarten-PIN ein`,
    COMP_CARD_ENTERING_NUMBER_HINT: `Geben Sie die Kompensationskartennummer ein. Die Nummer kann {{$1: number}} Stellen haben.`,
    COMP_CARD_ENTERING_PIN_HINT: `Geben Sie die Kompensationskarten-PIN ein. Die Nummer kann {{$1: length}} Stellen haben.`,
    COMP_CARD_ERROR_REMOVING: `Beim Entfernen der Kompensationskarte ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.`,
    'bottom-bar.storm-toggle.on': `Tippen, um Storm-Navigation zu aktivieren`,
    'bottom-bar.storm-toggle.off': `Tippen, um Storm-Navigation zu deaktivieren`,
    'campus-card.label': `Campuskarte`,
    'campus-card.payment-line-label': ``,
    'campus-card.payment-option-label': `Tippen, um mit Campuskarte zu bezahlen`,
    'campus-card.scan': `Campuskarte scannen`,
    'campus-card.scan-failed.title': `Scan der Campuskarte fehlgeschlagen`,
    'campus-card.scan-failed.message': `Beim Scannen der Campuskarte ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.`,
    'campus-card.enter-number': `Campuskartennummer eingeben`,
    'campus-card.enter-pin': `Campuskarten-PIN eingeben`,
    'campus-card.applying.title': `Campuskarte wird angewendet`,
    'campus-card.applying.error.title': `Fehler beim Anwenden der Campuskarte`,
    'campus-card.applying.error.message': `Beim Anwenden der Campuskarte ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.`,
    'campus-card.entering-number.error.required': `Bitte geben Sie eine Campuskartennummer ein`,
    'campus-card.entering-number.error.invalid': `Bitte geben Sie eine gültige Campuskartennummer ein`,
    'campus-card.entering-number.error.length': `Bitte geben Sie eine gültige Campuskartennummer ein`,
    'campus-card.entering-number.hint': `Geben Sie Ihre Campuskartennummer ein. Die Nummer kann {{$1: number}} Stellen haben.`,
    'campus-card.entering-pin.error.required': `Bitte geben Sie eine Campuskarten-PIN ein`,
    'campus-card.entering-pin.error.invalid': `Bitte geben Sie eine gültige Campuskarten-PIN ein`,
    'campus-card.entering-pin.error.length': `Bitte geben Sie eine gültige Campuskarten-PIN ein`,
    'campus-card.entering-pin.hint': `Geben Sie die Campuskarten-PIN ein. Die Nummer kann {{$1: length}} Stellen haben.`,
    'campus-card.error-removing': `Beim Entfernen der Campuskarte ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.`,
    'campus-card.no-balance.title': `Kein verfügbares Guthaben`,
    'campus-card.no-balance.message': `Diese Campuskarte hat kein verfügbares Guthaben.`,
    'campus-card.add-another': `Weitere hinzufügen`,
    'campus-card.remove': `Campuskarte entfernen`,
    'campus-card.select-account.title': `Konto auswählen`,
    'campus-card.select-account.loading': `Konten werden geladen...`,
    'campus-card.select-account.error.title': `Konten konnten nicht geladen werden`,
    'campus-card.select-account.error.message': `Ihre Konten konnten nicht geladen werden. Bitte versuchen Sie es erneut.`,
    'campus-card.select-account.column.account': `Konto`,
    'campus-card.select-account.column.balance': `Aktuelles Guthaben`,
    'campus-card.select-account.error.toast-title': `Fehler`,
    'campus-card.select-account.error.toast-message': `Validierung fehlgeschlagen. Bitte versuchen Sie es erneut.`,
    'campus-card.swipe': `Campuskarte durchziehen zum Bezahlen`,
    COUPON: `Coupon`,
    COUPON_ALREADY_USED: `Der Couponcode wurde bereits verwendet.`,
    COUPON_MIN_SPEND_NOT_MET: `Der eingegebene Couponcode erfüllt nicht den Mindestbestellwert.`,
    COUPON_NOT_FOUND: `Couponcode nicht gefunden.`,
    COUPON_NOT_ACCEPTED: `Der eingegebene Couponcode wurde nicht akzeptiert.`,
    COUPON_APPLYING: `Coupon wird angewendet`,
    COUPON_APPLYING_ERROR_TITLE: `Fehler beim Anwenden des Coupons`,
    COUPON_APPLYING_ERROR_MESSAGE: `Beim Anwenden des Coupons ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.`,
    COUPON_ORDER_REQUIREMENTS_NOT_MET: `Der eingegebene Couponcode erfüllt nicht die Bestellanforderungen.`,
    COUPON_SCANNING_ERROR_TITLE: `Fehler beim Scannen des Coupons`,
    COUPON_SCANNING_ERROR_MESSAGE: `Beim Scannen des Coupons ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.`,
    COUPON_ENTERING_ERROR_LENGTH: `Bitte geben Sie einen Couponcode ein.`,
    COUPON_ENTERING_ERROR_INVALID: `Bitte geben Sie einen gültigen Couponcode ein.`,
    COUPON_ERROR_REMOVING: `Beim Entfernen des Coupons ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an einen Mitarbeiter.`,
    CREATE_A_NEW_ACCOUNT: `Neues Konto erstellen`,
    CREATE_ACCOUNT: `Konto erstellen`,
    CREATE_ACCOUNT_TERMS_LINE: `Mit der Erstellung eines Kontos stimmen Sie den`,
    CREDIT_CARD: `Kreditkarte`,
    CREDIT_CARD_NUMBER: `Kartennummer`,
    CURBSIDE: `Abholung am Straßenrand`,
    CURRENT_PASSWORD: `Aktuelles Passwort`,
    CUSTOM_TIP: `Benutzerdefiniert`,
    CUSTOM_TIP_INVALID: `Bitte geben Sie einen gültigen Trinkgeldbetrag ein.`,
    CUSTOM_TIP_HINT: `Geben Sie Ihren Trinkgeldbetrag ein. Maximum: {{$1: number}}`,
    CUSTOM_DONATION: `Benutzerdefinierte Spende`,
    CUSTOMER_CARDS: `Gespeicherte Karte verwenden`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN: `Anmelden`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN_TOP_BAR: ``,
    CUSTOMER_ACCOUNT_BUTTON_LOGGED_IN: `Mein Konto`,
    CUSTOMIZE: `Anpassen`,
    DEBIT: `Debit`,
    DEBIT_CREDIT_CARD: `Debit-/Kreditkarte`,
    DEMO_PAY: `Demo: Bezahlen`,
    DELIVERY: `Lieferung`,
    DELIVERY_ADDRESS: `Lieferadresse`,
    DELIVERY_INSTRUCTIONS: ``,
    DESELECTED_MOD_PREFIX: `{{$1: mod name}} entfernen`,
    DINE_IN: `Im Restaurant essen`,
    DISCLAIMER_EMAIL: `Die Verwendung der E-Mail-Adresse unterliegt den Nutzungsbedingungen.`,
    DISCLAIMER_PHONE: `Die Verwendung der Telefonnummer unterliegt den Nutzungsbedingungen.`,
    DISCLAIMER_PHONE_LINK: `NUTZUNGSBEDINGUNGEN:`,
    DISCLAIMER_PHONE_DESCRIPTION: `FÜR DIE VERWENDUNG DER TELEFONNUMMER`,
    DISCLAIMER_NAME: `Ihr Name wird zur Bestätigung Ihrer Bestellung und zur Erleichterung der Abholung im ausgewiesenen Bereich verwendet.`,
    DISCOUNTS: `Rabatte`,
    DISCOUNTS_WILL_BE_APPLIED_AT_CHECKOUT: `Rabatte werden beim Bezahlen angewendet`,
    DISCOUNT_WILL_BE_APPLIED_AT_CHECKOUT: `Der Rabatt wird beim Bezahlen angewendet`,
    DONATION: `Spende`,
    DONATION_APPLYING: `Spende wird bearbeitet...`,
    DONATION_APPLY_ERROR_TITLE: `Fehler beim Anwenden der Spende`,
    DONATION_APPLY_ERROR_MESSAGE: `Beim Bearbeiten Ihrer Spende ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.`,
    DONATION_FAILED: `Die Spende ist fehlgeschlagen. Bitte versuchen Sie es erneut.`,
    DONATION_ROUND_UP_TITLE: `Möchten Sie den Gesamtbetrag aufrunden?`,
    DONATION_ROUND_UP_TO: `Auf {{$1: amount}} aufrunden`,
    DONATION_ROUND_UP_SUBTITLE: `Möchten Sie den Gesamtbetrag auf den nächsten vollen Euro aufrunden?`,
    DONATION_ROUND_UP_ACCEPT: `Ja, aufrunden`,
    DONATION_ROUND_UP_REJECT: `Nein, danke`,
    DONATION_REMOVE: `Spende entfernen`,
    DONE: `Fertig`,
    DONT_INCLUDE_UTENSILS: `Kein Besteck`,
    EBT: `SNAP EBT`,
    EBT_REFUND: `EBT-Erstattung`,
    EBT_CHOICE_DIALOG_TITLE: `Welche EBT-Methode möchten Sie verwenden?`,
    EBT_CHOICE_CASH_BENEFIT: `Bargeldleistung`,
    EBT_CHOICE_FOOD_STAMPS: `Lebensmittelmarken`,
    EBT_CARD_SUBTITLE: `Ziehen Sie Ihre EBT-Karte am Kartenlesegerät durch`,
    EDIT: `Bearbeiten`,
    EDIT_ORDER: `Bestellung bearbeiten`,
    EDIT_TIP: `Trinkgeld bearbeiten`,
    SAVE_ORDER: `Bestellung speichern`,
    SAVE_BUTTON: ``,
    EMAIL_ADDRESS: `E-Mail-Adresse`,
    EMAIL_RECEIPT: `Quittung per E-Mail`,
    EMAIL_REQUIRED_FOR_RECEIPT: `Für die Quittung ist eine E-Mail-Adresse erforderlich.`,
    EMAIL_RECEIPT_SEND_FAILED: `Quittung konnte nicht gesendet werden. Bitte versuchen Sie es erneut.`,
    EMAIL_RECEIPT_SEND_SUCCESS: `Quittung erfolgreich gesendet.`,
    ENTER_ACCESS_CODE: `Zugangscode eingeben:`,
    ENTER_EMAIL_CUSTOMER_IDENTIFIER: `E-Mail eingeben`,
    ENTER_GIFT_CARD_BARCODE_FALLBACK: `Können Sie nicht scannen? Geben Sie Ihre Kartennummer ein.`,
    ENTER_PHONE_CONSENT: `Ich stimme dem Erhalt von Marketingmaterial per SMS zu.`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER: `Telefonnummer eingeben`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER_WITH_NAME: `Hallo {{$1 guest name}}, bitte geben Sie Ihre Telefonnummer ein`,
    ENTER_PHONE_LOYALTY: `Mobiltelefonnummer eingeben`,
    ENTER_PHONE_RECEIPT: `Geben Sie Ihre Mobiltelefonnummer ein, um eine Quittung zu erhalten`,
    ENTER_PHONE_TEXT_WHEN_READY: `Geben Sie Ihre Telefonnummer ein, um eine SMS zu erhalten, wenn Ihre Bestellung fertig ist!`,
    ENTER_VEHICLE_DESCRIPTION: `Bitte geben Sie Ihre Fahrzeugdaten ein, damit wir Ihre Bestellung bringen können:`,
    ENTER_YOUR_COUPON_CODE: `Couponcode eingeben`,
    ENTER_YOUR_COMP_CARD_NUMBER: `Kompensationskartennummer eingeben`,
    ENTER_YOUR_COMP_CARD_PIN: `Kompensationskarten-PIN eingeben`,
    ENTER_YOUR_GIFT_CARD_NUMBER: `Geschenkkartennummer eingeben`,
    ENTER_YOUR_GIFT_CARD_PIN: `Geschenkkarten-PIN eingeben`,
    ENTER_YOUR_EMAIL: `E-Mail eingeben:`,
    ENTER_YOUR_EMAIL_VALIDATION_FAILED: `Ungültige E-Mail. Bitte versuchen Sie es erneut.`,
    ENTER_YOUR_FIRST_NAME: `Vornamen eingeben:`,
    ENTER_YOUR_LAST_NAME: `Initiale des Nachnamens eingeben:`,
    ENTER_YOUR_NAME: `Namen eingeben:`,
    ENTER_YOUR_NAME_VALIDATION_FAILED: `Ungültiger Name. Bitte versuchen Sie es erneut.`,
    ENTER_YOUR_NAME_VALIDATION_LENGTH_FAILED: `Bitte geben Sie einen Namen ein.`,
    ENTER_YOUR_LAST_NAME_VALIDATION_LENGTH_FAILED: `Nur ein Buchstabe ist erlaubt. Bitte versuchen Sie es erneut.`,
    ENTER_YOUR_NAME_VALIDATION_FORMAT_FAILED: `Der Name darf nur Buchstaben enthalten. Bitte versuchen Sie es erneut.`,
    ENTER_YOUR_NAME_VALIDATION_PROFANITY_FAILED: `Der Name enthält unangemessene Wörter. Bitte versuchen Sie es erneut.`,
    ERROR: `Hoppla!`,
    ERROR_ADDING_ITEM: `Beim Hinzufügen des Artikels zum Warenkorb ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an einen Mitarbeiter in Ihrer Nähe.`,
    ERROR_EDITING_ITEM: `Beim Bearbeiten des Artikels im Warenkorb ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an einen Mitarbeiter in Ihrer Nähe.`,
    ERROR_AMOUNT_EXCEEDS_BALANCE: `Der Betrag übersteigt das Kartenguthaben.`,
    ERROR_CARD_CONFIRMATION: `Entschuldigung! Die Karte konnte nicht bestätigt werden. Bitte versuchen Sie es erneut.`,
    ERROR_CARD_DECLINED: `Die angegebene Karte konnte nicht belastet werden. Bitte versuchen Sie es erneut.`,
    ERROR_CARD_INACTIVE: `Entschuldigung, dieser Studentenausweis ist nicht aktiv.`,
    ERROR_CARD_NOT_FOUND: `Entschuldigung! Diese Karte wurde nicht gefunden. Bitte versuchen Sie es erneut.`,
    ERROR_CARD_NUMBER_LENGTH: `Die Kartennummer hat nicht die richtige Länge.`,
    ERROR_CARD_RESTRICTED_TIME: `Entschuldigung, diese Karte kann derzeit nicht verwendet werden.`,
    ERROR_CARD_SCHEME_NOT_ACCEPTED: `Entschuldigung, {{$1: cardScheme}} wird hier nicht akzeptiert. Könnten Sie eine andere Karte versuchen?`,
    ERROR_COUPON_CONFIRMATION: `Entschuldigung! Der Couponcode konnte nicht verwendet werden. Bitte versuchen Sie es erneut.`,
    ERROR_INVALID_EMAIL: `Ungültige E-Mail-Adresse`,
    ERROR_INVALID_LOGIN_CREDS: `Ungültiger Benutzername oder Passwort`,
    ERROR_INVALID_NAME: `Bitte geben Sie einen gültigen Namen ein`,
    ERROR_INVALID_PHONE_NUMBER: `Bitte geben Sie eine gültige Telefonnummer ein`,
    ERROR_INVALID_ROOM_NUMBER: `Bitte geben Sie eine gültige Zimmernummer ein`,
    ERROR_INVALID_TABLE_NUMBER: `Bitte geben Sie eine gültige Tischnummer ein`,
    ERROR_INVALID_VERIFICATION_CODE: `Ungültiger Bestätigungscode`,
    ERROR_KIOSK_CARD_DECLINED: `Es ist ein Problem aufgetreten. Ihre Karte wurde nicht belastet. Bitte versuchen Sie es erneut.`,
    ERROR_KIOSK_CARD_DECLINED_TAP: `Karte konnte nicht gelesen werden. Bitte versuchen Sie es erneut.`,
    ERROR_KIOSK_PAYMENT_DEVICE_NOT_FOUND: `Der Kiosk konnte das Zahlungsgerät nicht finden. Ihre Karte wurde nicht belastet. Bitte wenden Sie sich an einen Mitarbeiter.`,
    ERROR_KIOSK_PAYMENT_DEVICE_OFFLINE: `Das Zahlungsgerät scheint offline zu sein. Ihre Karte wurde nicht belastet. Bitte wenden Sie sich an einen Mitarbeiter.`,
    ERROR_ORDER_OPERATION: `Entschuldigung, Ihre Bestellung konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.`,
    ERROR_PIN_LENGTH: `Die PIN hat nicht die richtige Länge.`,
    ERROR_RECEIVING_PAYMENT: `Das Terminal konnte Ihre Zahlung nicht verarbeiten. Bitte versuchen Sie es erneut.`,
    ERROR_RECEIVING_PAYMENT_INSTRUCTIONS: `Keine Zahlung eingegangen. Diese Bestellung wurde nicht gesendet. Ihre Quittung enthält eine Zusammenfassung Ihrer Bestellung. Bitte wenden Sie sich an einen Mitarbeiter.`,
    ERROR_SENDING_ORDER: `Es scheint ein Problem beim Senden Ihrer Bestellung an die Küche zu geben. Bitte wenden Sie sich an einen Mitarbeiter.`,
    ERROR_SENDING_ORDER_INSTRUCTIONS: `Die Zahlung war erfolgreich, aber es gab ein Problem beim Senden Ihrer Bestellung an die Küche. Bitte wenden Sie sich an einen Mitarbeiter. Ihre Quittung enthält eine Zusammenfassung Ihrer Bestellung.`,
    ERROR_STARTING_ORDER: `Entschuldigung, Ihre Bestellung konnte nicht gestartet werden. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an einen Mitarbeiter.`,
    ERROR_UPDATING_ORDER: `Entschuldigung, Ihre Bestellung konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an einen Mitarbeiter.`,
    ERROR_VIEWING_ITEM_ALCOHOL_LIMIT: `Dieser Artikel kann nicht angezeigt werden. Sie haben das Alkohollimit für diese Bestellung erreicht. Bitte entfernen Sie ein alkoholisches Getränk, um dieses hinzuzufügen.`,
    ERROR_VIEWING_ITEM_SPECIAL_OFFER_LIMIT: `Dieser Artikel kann nicht angezeigt werden. Sie haben das Sonderangebotslimit für diese Bestellung erreicht. Bitte entfernen Sie einen Sonderangebotsartikel, um diesen hinzuzufügen.`,
    EXIT: `Beenden`,
    EXIT_CONFIRMATION: `Möchten Sie wirklich beenden? Beim Beenden wird Ihre Bestellung gelöscht.`,
    EXIT_TO_COVER: ``,
    FAVORITE: `Favorit`,
    FAVORITES: `Favoriten`,
    FAVORITES_NONE_YET: `Noch keine Favoriten.`,
    FAVORITES_REMOVE_CONFIRMATION: `Möchten Sie diesen Favoriten wirklich entfernen?`,
    FETCHING_RECOMMENDATIONS: `Empfehlungen werden abgerufen...`,
    FIND_ACCOUNT: `Konto suchen`,
    FIRST_NAME: `Vorname`,
    FORGOT_PASSWORD: `Passwort vergessen?`,
    FULFILLMENT_LABEL_ADDRESS: `Adresse`,
    FULFILLMENT_LABEL_GUEST_EMAIL: `E-Mail`,
    FULFILLMENT_LABEL_GUEST_NAME: `Für`,
    FULFILLMENT_LABEL_ORDER_NUMBER: `Bestellnummer`,
    FULFILLMENT_LABEL_TABLE_NUMBER: `Tischnummer`,
    FULFILLMENT_LABEL_PHONE_NUMBER: `Telefonnummer`,
    FULFILLMENT_LABEL_TRACKER_NUMBER: `Trackernummer`,
    FULFILLMENT_LABEL_VEHICLE_DESCRIPTION: `Fahrzeugbeschreibung`,
    FULFILLMENT_INSTRUCTION_ADDRESS: `Ihre Bestellung wird an die folgende Adresse geliefert.`,
    FULFILLMENT_INSTRUCTION_GUEST_EMAIL: `Wir senden Ihnen die Quittung.`,
    FULFILLMENT_INSTRUCTION_GUEST_NAME: `Ihr Name wird aufgerufen, wenn Ihre Bestellung fertig ist.`,
    FULFILLMENT_INSTRUCTION_ORDER_NUMBER: `Ihre Bestellnummer wird aufgerufen.`,
    FULFILLMENT_INSTRUCTION_PHONE_NUMBER: `Sie erhalten eine SMS, wenn Ihre Bestellung fertig ist.`,
    FULFILLMENT_INSTRUCTION_TABLE_NUMBER: `Ihre Bestellung wird an Ihren Tisch gebracht.`,
    FULFILLMENT_INSTRUCTION_TRACKER_NUMBER: `Ihr Tracker klingelt, wenn die Bestellung fertig ist.`,
    FULFILLMENT_INSTRUCTION_VEHICLE_DESCRIPTION: `Sobald Sie vor dem Restaurant angekommen sind, bringen wir Ihnen Ihre Bestellung.`,
    FULFILLMENT_TOGGLE: `Aktive Abholmethode umschalten`,
    FULL_NAME: `Vollständiger Name`,
    FUTURE_ORDER_MENU_FETCH_ERROR: `Entschuldigung! Das Menü für diesen Zeitslot wurde nicht gefunden. Bitte versuchen Sie es erneut.`,
    FUTURE_ORDER_NO_AVAILABLE_SLOTS: `Entschuldigung! Keine verfügbaren Zeitslots gefunden. Bitte versuchen Sie eine andere Essensoption.`,
    FUTURE_ORDER_SET_FOR: `Bestellung geplant für:`,
    FUTURE_ORDER_VALIDATION_WHEN_SLOT_EXPIRED_ERROR: `Entschuldigung! Der gewählte Zeitslot ist nicht mehr verfügbar. Bitte wählen Sie einen anderen Zeitpunkt.`,
    FUTURE_ORDER_ERROR_FETCHING_SLOTS: `Beim Laden der verfügbaren Zeitslots ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an einen Mitarbeiter.`,
    FUTURE_ORDER_ERROR_SELECT_SLOT: `Bitte wählen Sie einen Zeitslot.`,
    FUTURE_ORDER_TIME_SLOTS_TITLE: `Zeitslots`,
    FUTURE_ORDER_TIME_SLOTS_TODAY: `Heute`,
    FUTURE_ORDER_TIME_SLOTS_TOMORROW: `Morgen`,
    FUTURE_ORDER_PICKUP_TIME_TODAY_AT: `Abholung heute um {{$1: time}}`,
    FUTURE_ORDER_PICKUP_TIME_NEXT_BUSINESS_DAY_AT: `Abholung am nächsten Werktag um {{$1: time}}`,
    FUTURE_ORDER_LEAD_TIME: `Geschätzte Zubereitungszeit: {{$1: time}}`,
    GENERIC_ERROR: `Hoppla! Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an einen Mitarbeiter.`,
    GET_REWARDS: `Prämien erhalten`,
    GET_RECEIPT: `Quittung erhalten`,
    GET_RECEIPT_DIALOG_TITLE: `Quittungsoptionen`,
    GIFT_CARD: `Geschenkkarte`,
    GIFT_CARD_SECONDARY: `Alternative Geschenkkarte`,
    GIFT_CARD_TITLE: `Jetzt bezahlen`,
    GIFT_CARD_SUBTITLE: `Bezahlen Sie, indem Sie Ihre Geschenkkarte am Kartenlesegerät durchziehen.`,
    GIFT_CARD_SCANNING_ERROR_TITLE: `Fehler beim Scannen der Geschenkkarte`,
    GIFT_CARD_SCANNING_ERROR_MESSAGE: `Ihre Geschenkkarte konnte nicht gescannt werden. Bitte versuchen Sie es erneut.`,
    GIFT_CARD_APPLYING_TITLE: `Geschenkkarte wird angewendet`,
    GIFT_CARD_APPLYING_ERROR_TITLE: `Fehler beim Anwenden der Geschenkkarte`,
    GIFT_CARD_APPLYING_ERROR_MESSAGE: `Ihre Geschenkkarte konnte nicht angewendet werden. Bitte versuchen Sie es erneut.`,
    GIFT_CARD_NO_BALANCE_TITLE: `Geschenkkarte hat kein Guthaben`,
    GIFT_CARD_NO_BALANCE_MESSAGE: `Ihre Geschenkkarte hat kein Guthaben.`,
    GIFT_CARD_ADD_ANOTHER: `Weitere hinzufügen`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `Bitte geben Sie eine Geschenkkartennummer ein.`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_INVALID: `Bitte geben Sie eine gültige Geschenkkartennummer ein.`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_LENGTH: `Bitte geben Sie eine gültige Geschenkkartennummer ein.`,
    GIFT_CARD_ENTERING_PIN_ERROR_REQUIRED: `Bitte geben Sie eine PIN ein.`,
    GIFT_CARD_ENTERING_PIN_ERROR_INVALID: `Bitte geben Sie eine gültige PIN ein.`,
    GIFT_CARD_ENTERING_PIN_ERROR_LENGTH: `Bitte geben Sie eine gültige PIN ein.`,
    GIFT_CARD_ENTERING_NUMBER_HINT: `Geben Sie die Geschenkkartennummer ein. Die Nummer kann {{$1: length}} Stellen haben.`,
    GIFT_CARD_ENTERING_PIN_HINT: `Geben Sie die PIN ein. Die Nummer kann {{$1: length}} Stellen haben.`,
    GIFT_CARD_ERROR_REMOVING: `Fehler beim Entfernen der Geschenkkarte. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an einen Mitarbeiter.`,
    'gift-card.select-account.title': `Konto auswählen`,
    'gift-card.select-account.loading': `Konten werden geladen...`,
    'gift-card.select-account.error.title': `Konten konnten nicht geladen werden`,
    'gift-card.select-account.error.message': `Ihre Konten konnten nicht geladen werden. Bitte versuchen Sie es erneut.`,
    'gift-card.select-account.column.account': `Konto`,
    'gift-card.select-account.column.balance': `Aktuelles Guthaben`,
    'gift-card.select-account.error.toast-title': `Fehler`,
    'gift-card.select-account.error.toast-message': `Validierung fehlgeschlagen. Bitte versuchen Sie es erneut.`,
    GLOSSARY_TERM_LEARN_MORE: `Mehr erfahren`,
    GOES_WELL_WITH: `Passt gut zu`,
    GRAND_TOTAL: `Gesamtbetrag`,
    GROUP_ORDERING_ADD_GUEST: `Gast hinzufügen`,
    GROUP_ORDERING_GUEST_NAME_INVALID_CHARACTERS: `Der Gastname enthält ungültige Zeichen.`,
    GROUP_ORDERING_GUEST_NAME_TAKEN: `Dieser Gastname wird bereits verwendet. Bitte geben Sie einen anderen Namen ein.`,
    GROUP_ORDERING_GUEST_NUMBER_PREFIX: `Gast {{$1: number}}`,
    GROUP_ORDERING_ITEM_FOR: `Gruppenbestellung – Für wen ist dieser Artikel?`,
    GROUP_ORDERING_LABEL: `Gruppenbestellung – Artikel für:`,
    GROUP_ORDERING_TITLE: `Gruppenbestellung`,
    GROUP_ORDERING_SUBTITLE: `Bei der Gruppenbestellung werden Sie gefragt, welchem Mitglied Ihrer Gruppe jeder Artikel gehört. Tippen Sie auf „Ja", um die Gruppenbestellung zu aktivieren. Tippen Sie auf „Nein", um fortzufahren.`,
    GUEST_INFO: `Gastinformationen`,
    GUEST_RATING_LABEL_0: `Tippen, um mit 0 zu bewerten: Sehr unzufrieden`,
    GUEST_RATING_LABEL_1: `Tippen, um mit 1 zu bewerten: Eher unzufrieden`,
    GUEST_RATING_LABEL_2: `Tippen, um mit 2 zu bewerten: Eher zufrieden`,
    GUEST_RATING_LABEL_3: `Tippen, um mit 3 zu bewerten: Sehr zufrieden`,
    GUEST_RATING_0: `Vielen Dank für Ihr Feedback!`,
    GUEST_RATING_1: `Vielen Dank für Ihr Feedback!`,
    GUEST_RATING_2: `Vielen Dank für Ihr Feedback!`,
    GUEST_RATING_3: `Vielen Dank für Ihr Feedback!`,
    GUEST_RATING_SUBMITTED: `Vielen Dank für Ihr Feedback!`,
    HIDE: `Ausblenden`,
    HOME: `Startseite`,
    HOW_DID_WE_DO: `Wie haben wir abgeschnitten? Bewerten Sie uns!`,
    HOW_WOULD_YOU_LIKE_TO_PAY: `Wie möchten Sie bezahlen?`,
    HOW_WOULD_YOU_LIKE_YOUR_ORDER: `Wie möchten Sie Ihre Bestellung erhalten?`,
    KITCHEN_CLOSED: `Entschuldigung, die Küche ist geschlossen.`,
    ID_CHECK_LABEL: `Ihre Bestellung enthält Alkohol. Möglicherweise wird ein Ausweis verlangt.`,
    ID_CHECK_CODE_MESSAGE: `Für den Kauf alkoholischer Produkte wird ein Mitarbeiterzugangscode benötigt. Bitte bitten Sie ein Teammitglied um Hilfe.`,
    IE_WARNING: `Wir haben festgestellt, dass Sie unsere Website über Internet Explorer aufrufen. Für ein optimales Erlebnis öffnen Sie sie bitte mit unterstützten Browsern wie Google Chrome, Safari, Firefox oder Microsoft Edge.`,
    INCLUDE_UTENSILS: `Besteck einschließen`,
    ITEM_86D: `Es scheint ein Problem beim Senden Ihrer Bestellung an die Küche zu geben, da ein Artikel nicht vorrätig ist. Bitte wenden Sie sich an einen Mitarbeiter.`,
    ITEM_86D_VALIDATION: `Hallo, es scheint ein Problem beim Senden Ihrer Bestellung an die Küche zu geben, da ein Artikel nicht vorrätig ist. Bitte wenden Sie sich an einen Mitarbeiter für Hilfe.`,
    ITEM_RECIPIENT: `Zubereitet für`,
    ITEM_RECIPIENT_FOR: `Zubereitet für {{$1: recipient}}`,
    ITEM_RECIPIENT_PLACEHOLDER: ``,
    ITEM_RECOMMENDED_BADGE: `Empfohlen`,
    ITEM_STEP_TITLE: `Schritt {{$1: step}}`,
    ITEM_STEP_EMPTY: `In diesem Schritt wurde keine Auswahl getroffen`,
    ITEM_STEP_NO_RECOS: `Keine Empfehlungen verfügbar`,
    ITEMS_NO_LONGER_IN_MENU: `Einige Artikel wurden aus Ihrem Warenkorb entfernt, da sie nicht mehr im Menü sind`,
    ITEM_SCAN_ERROR: `Wir konnten diesen Artikel nicht finden. Bitte fügen Sie ihn über das Menü hinzu oder wenden Sie sich an einen Mitarbeiter.`,
    ITEM_SCAN_SUCCESS: `Artikel zum Warenkorb hinzugefügt!`,
    LAST_NAME: `Nachname`,
    LEAD_TIME_LONG: `Ihre Bestellung kann länger dauern als der aktuell gewählte Zeitslot.`,
    LEAD_TIME_CART: `Diese Bestellung kann aufgrund einiger ausgewählter Artikel länger dauern als die angeforderte Abholzeit.`,
    LANGUAGE_SELECT_LABEL: `Tippen, um Sprache auszuwählen`,
    LOADING: `Wird geladen...`,
    LOADING_MENU: `Menü wird geladen...`,
    LOCATION_CARD_CLOSED: ``,
    LOCATION_CARD_LAST_VISITED: ``,
    LOCATION_CARD_OPEN: ``,
    LOCATION_CARD_SERVING_UNTIL: ``,
    LOCATION_CARD_OPENS_NEXT: ``,
    LOCATION_SEARCH_BUTTON: `Restaurants suchen`,
    LOCATION_SEARCH_FULFILLMENT_PROMPT: `Restaurant für {{$1: dine-in/take-away}} suchen`,
    LOCATION_SEARCH_FULFILLMENT_QUESTION: `Wie möchten Sie bestellen?`,
    LOCATION_SEARCH_HEADER: `Willkommen bei {{$1: org name}}`,
    LOCATION_SEARCH_INPUT_PLACEHOLDER: `Adresse, Stadt und Bundesland oder Postleitzahl`,
    LOCATIONS_CHOOSE_A_LOCATION: ``,
    LOCATIONS_ENTER_DIFFERENT_CODE: ``,
    LOCATIONS_NONE_AVAILABLE: ``,
    LOG_IN_OR_JOIN: `Anmelden`,
    LOGIN: `Anmelden`,
    LOGIN_GIFT_CARD: `Anmeldung mit Geschenkkarte`,
    LOGIN_GIFT_CARD_SECONDARY: `Anmeldung mit alternativer Geschenkkarte`,
    LOGIN_WALL_WELCOME: `Hallo!`,
    LOGIN_WALL_WELCOME_USER: `Hallo, {{$1: user}}!`,
    LOGIN_WITH_CARD_NUMBER: `Mit Kartennummer anmelden`,
    LOGIN_WITH_PHONE: `Mit Telefon anmelden`,
    LOOKING_UP_ACCOUNT: `Konto wird gesucht...`,
    LOOKUP_CARD: `Karte wird gesucht...`,
    LOOKUP_COUPON: `Coupon wird gesucht...`,
    LOYALTY: `Treueprogramm`,
    LOYALTY_ACCOUNT_APPLY: `Anwenden`,
    LOYALTY_CARD_NUMBER: `Kartennummer`,
    LOYALTY_EXIT_TO_MENU: `Zum Menü`,
    LOYALTY_APP_AUTH_BARCODE_FALLBACK: `App-QR-Code scannen`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK: `Keine App? Geben Sie Ihre Telefonnummer ein.`,
    LOYALTY_AUTH_METHOD_BARCODE: `App-QR-Code scannen`,
    LOYALTY_AUTH_METHOD_HID: `HID-Karte antippen`,
    LOYALTY_AUTH_METHOD_PHONE: `Geben Sie Ihre Telefonnummer ein.`,
    LOYALTY_AUTH_METHOD_CARD_NUMBER: `Geben Sie Ihre Kartennummer ein.`,
    LOYALTY_AUTH_METHOD_EMAIL: `Geben Sie Ihre E-Mail ein.`,
    LOYALTY_AUTH_METHOD_EMAIL_PASSWORD: `Geben Sie Ihre E-Mail und Ihr Passwort ein.`,
    LOYALTY_AUTH_METHOD_EMAIL_PHONE: `Geben Sie Ihre E-Mail und Telefonnummer ein.`,
    LOYALTY_AUTH_METHOD_USERNAME_PASSWORD: `Geben Sie Ihren Benutzernamen und Ihr Passwort ein.`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK_LABEL: `Telefonnummer des Kontos eingeben:`,
    LOYALTY_APP_AUTH_SUBTITLE: `Um den Barcode zu finden, öffnen Sie Ihre App auf dem ZAHLEN-Bildschirm.`,
    LOYALTY_APP_AUTH_TITLE: `Scannen Sie den Zahlungsbarcode Ihrer App mit dem Scanner unten.`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK: `7-stelligen Prämiecode manuell eingeben`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK_LABEL: `7-stelligen Prämiecode eingeben:`,
    LOYALTY_APPLY_REWARD_FAILED: `Prämie konnte nicht angewendet werden. Bitte versuchen Sie es erneut.`,
    LOYALTY_APPLY_REWARD_FAILED_SPECIFIC: `Folgende Prämien konnten nicht angewendet werden: {{$1: reward names}}. Bitte versuchen Sie es erneut.`,
    LOYALTY_APPLYING_REWARD: `Prämie wird angewendet...`,
    LOYALTY_AUTH_GENERIC_ERROR: `Entschuldigung! Dieses Prämienkonto wurde nicht gefunden. Bitte versuchen Sie es erneut.`,
    LOYALTY_AUTH_INSTRUCTIONS: `Melden Sie sich an, um Punkte zu sammeln und zu verwenden.`,
    LOYALTY_AVAILABLE_REWARDS_LABEL: `Verfügbare Prämien`,
    LOYALTY_BALANCE_DESCRIPTION: ``,
    LOYALTY_BALANCE_LABEL: `Aktuelles Guthaben`,
    LOYALTY_CANNOT_MODIFY_REWARD: `Entschuldigung, Sie können Ihre Prämien nicht mehr ändern, nachdem Sie die Bestellung bezahlt haben.`,
    LOYALTY_CANNOT_REMOVE_REWARD: `Entschuldigung, diese Prämie kann nicht mehr entfernt werden, nachdem sie auf die Bestellung angewendet wurde.`,
    LOYALTY_CARD_NUMBER_INSTRUCTIONS: `Geben Sie Ihre Kartennummer ein, um Punkte zu sammeln und zu verwenden.`,
    LOYALTY_COUPON_BURNING_INCOMPATIBLE: `Entschuldigung, Sie können Ihre Prämien nicht nutzen, da ein Coupon angewendet wurde.`,
    LOYALTY_GETTING_REWARDS: `Ihre Prämien werden abgerufen...`,
    LOYALTY_FETCH_REWARDS_FAILED: `Prämien konnten nicht abgerufen werden. Bitte versuchen Sie es erneut.`,
    LOYALTY_REWARD_APPLY: `Anwenden`,
    LOYALTY_REWARD_APPLY_FAILED: `Prämien konnten nicht angewendet werden. Einige Prämien gelten möglicherweise nicht für Ihre Bestellung.`,
    LOYALTY_REWARD_APPLIED: `Angewendet`,
    LOYALTY_REWARD_INVALID: `Ungültig`,
    LOYALTY_REWARD_LABEL_MEAL: `Mahlzeit`,
    LOYALTY_REWARD_LABEL_MEALS: `Mahlzeiten`,
    LOYALTY_REWARD_LABEL_UNSELECTED: `Jetzt einlösen`,
    LOYALTY_REWARD_LABEL_SELECTED: `Ausgewählt`,
    LOYALTY_REWARD_LABEL_APPLIED: `Eingelöst`,
    LOYALTY_REWARD_LABEL_UNAPPLIED: `Beim Bezahlen einlösen`,
    LOYALTY_REWARD_LABEL_REMOVING: `Wird entfernt`,
    LOYALTY_REWARD_LABEL_ERROR: `Anwendungsfehler`,
    LOYALTY_REWARD_LABEL_UNAPPLICABLE: `Nicht anwendbar`,
    LOYALTY_REWARD_GROUP_LABEL_UNKNOWN: `Prämien`,
    LOYALTY_REWARD_GROUP_LABEL_PERCENT: `Prozentbasierte Prämien`,
    LOYALTY_REWARD_GROUP_LABEL_FIXED: `Feste Prämien`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET: `Geldbörsen-Prämien`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET_AND_PAYMENT: `Geldbörsen- und Zahlungsprämien`,
    LOYALTY_REWARD_GROUP_LABEL_FREE_ITEM: `Gratisprämien`,
    LOYALTY_REWARD_GROUP_LABEL_MEAL_EQUIVALENCY: `Mahlzeiten-Tauschprämien`,
    LOYALTY_REWARDS_FOR: ` für`,
    LOYALTY_NO_REWARDS_LABEL: `Keine Prämien`,
    LOYALTY_NO_REWARDS_NO_EARNING: `Für diese Artikel sind keine Prämien verfügbar.`,
    LOYALTY_NO_REWARDS_TEXT: `Für diese Artikel sind keine Prämien verfügbar, aber Sie sammeln trotzdem Punkte mit dieser Bestellung!`,
    LOYALTY_PAYMENT: `Mit Treueprogramm`,
    LOYALTY_PAYMENT_CARD_CHARGED: `{{$1: charge_amount}} wird von der gespeicherten Karte abgebucht.`,
    LOYALTY_PAYMENT_FAILED: `Zahlung konnte nicht angewendet werden.`,
    LOYALTY_PAYMENT_FAILED_MESSAGE: `Bei der Verarbeitung der Treueprogramm-Zahlung ist ein Problem aufgetreten. Bitte versuchen Sie es erneut oder wählen Sie eine andere Zahlungsmethode.`,
    USE_LOYALTY_PAYMENT: `Treueprogramm verwenden`,
    LOYALTY_PAYMENT_SUBMIT: `Zahlung abschließen`,
    LOYALTY_PAYMENT_REWARD: `Vom Treueprogramm abgebucht`,
    LOYALTY_PAYMENT_REWARD_DESCRIPTION: `Ihre beim Anbieter gespeicherte Karte wird für diese Transaktion belastet.`,
    LOYALTY_PAY_WITH_APP: `Mit App bezahlen`,
    LOYALTY_EARNED_POINT_ESTIMATE: `Geschätzte Prämienpunkte für diese Bestellung:`,
    LOYALTY_EARNED_POINT_ESTIMATE_METRIC: `{{$1: number}} Punkte`,
    LOYALTY_INTRO_ACCOUNT_STATUS: `Kontostatus`,
    LOYALTY_INTRO_COULD_NOT_FIND_ACCOUNT: `Ihr Konto wurde nicht gefunden.`,
    LOYALTY_INTRO_LOGIN_AND_EARN: `Bitte melden Sie sich unten in Ihrem Konto an, um Punkte zu sammeln und Prämien einzulösen.`,
    LOYALTY_INTRO_PHONE_SIGN_UP: `Mit Telefonnummer registrieren`,
    LOYALTY_INTRO_PHONE_SIGN_UP_DESCRIPTION: `Sie können noch Punkte für die heutige Bestellung sammeln, indem Sie die Quittung nach der Registrierung scannen!`,
    LOYALTY_INTRO_QR_SIGN_IN: `Bitte scannen Sie den QR-Code unten, um sich anzumelden.`,
    LOYALTY_INTRO_QR_SIGN_UP: `Bitte scannen Sie den QR-Code unten, um sich zu registrieren.`,
    LOYALTY_INTRO_WELCOME_BACK: `Willkommen zurück,`,
    LOYALTY_FETCH_REWARDS_FAILED_NON_UNIQUE: `Die angegebene Telefonnummer ist mit mehr als einem Treuekonto verknüpft oder existiert nicht.`,
    LOYALTY_REDEMPTION_CODE: `Einlösecode anwenden`,
    LOYALTY_REMOVING_REWARD: `Prämie wird entfernt...`,
    LOYALTY_SCAN_FAILED_TITLE: `Scan fehlgeschlagen`,
    LOYALTY_SCAN_FAILED_MESSAGE: `Ihr QR-Code konnte nicht gescannt werden. Bitte versuchen Sie es erneut.`,
    LOYALTY_SIGN_OUT_NOTICE: `Sie werden automatisch abgemeldet, wenn die Bestellung aufgegeben wird oder Sie das Menü verlassen.`,
    LOYALTY_SIGN_OUT_NOTICE_PASSWORD: `Sie werden automatisch abgemeldet, wenn die Bestellung aufgegeben wird oder Sie das Menü verlassen. Passwörter werden nie gespeichert.`,
    LOYALTY_SIGN_UP_SMS_SENT: `Registrierungsnachricht gesendet!`,
    LOYALTY_SIGN_UP_BACK_TO_LOGIN: `Zurück zur Anmeldung`,
    LOYALTY_SIGN_UP_SUCCESS_TITLE: `Registrierung erfolgreich!`,
    LOYALTY_SIGN_UP_WITH_QR: `Mit QR-Code registrieren`,
    LOYALTY_SIGN_UP_WITH_PHONE_NUMBER: `Mit Telefonnummer registrieren`,
    LOYALTY_WELCOME_TITLE: `Punkte sammeln und einlösen`,
    LOYALTY_SIGNUP_TITLE: `Registrierungslink aufs Telefon senden`,
    LOYALTY_YOU_CURRENTLY_HAVE: `Sie haben derzeit`,
    LOYALTY_NAV_REWARDS: `Meine Prämien`,
    LOYALTY_NAV_ORDER_HISTORY: `Meine Bestellungen`,
    LOYALTY_SIGN_IN_ATTEMPTS_EXCEEDED: `Sie haben die maximale Anzahl an Anmeldeversuchen überschritten.`,
    GIFT_CARD_ACCESS_ATTEMPTS_EXCEEDED: `Sie haben die maximale Anzahl an Zugriffsversuchen auf die Geschenkkarte überschritten.`,
    MAKE_IT_A_COMBO: `Als Menü?`,
    MAKE_IT_A_COMBO_MOD: `Als Menü?`,
    MAKE_IT_A_COMBO_ACCEPT: `Ja, bitte!`,
    MAKE_IT_A_COMBO_REJECT: `Nein, danke!`,
    MAKE_IT_A_COMBO_NO: `Nein, danke, kein Menü.`,
    MAKE_IT_A_COMBO_YES: `Als Menü?`,
    MAKE_IT_A_COMBO_ACCEPTED_TITLE: `Ausgezeichnete Wahl!`,
    MAKE_IT_A_COMBO_ACCEPTED_MESSAGE: `Wählen Sie unten Ihre Beilage und Ihr Getränk!`,
    MAKE_IT_A_COMBO_CHECKOUT_UPSELL_SUBTITLE: `Fügen Sie eine Beilage und ein Getränk hinzu, um ein Menü zu machen!`,
    MENU_COVER_ALT_TEXT: `Hier tippen, um zu bestellen`,
    MENU_COVER_LOYALTY_TEXT: `Im Treueprogramm anmelden, um Punkte zu sammeln und Prämien einzulösen`,
    MENU_COVER_QUIZ_TEXT: `Machen Sie das Quiz, um herauszufinden, welcher Artikel ideal für Sie ist!`,
    MENU_COVER_WAYFINDER_TEXT: `Besuchen Sie unseren Wegweiser, um sich zu orientieren`,
    MAINTENANCE_COVER_TITLE: `Dieser Kiosk wird gewartet`,
    MAINTENANCE_HID_DISCONNECTED_MESSAGE: `Bitte stellen Sie sicher, dass das HID mit dem Kiosk verbunden ist.`,
    MAINTENANCE_HID_DISCONNECTED_TITLE: `HID getrennt`,
    MAINTENANCE_KDS_DISCONNECTED_MESSAGE: `Bitte stellen Sie sicher, dass das KDS mit dem Kiosk verbunden ist.`,
    MAINTENANCE_KDS_DISCONNECTED_TITLE: `KDS getrennt`,
    MAINTENANCE_KIOSK_UNAVAILABLE_MESSAGE: `Bitte versuchen Sie einen anderen Kiosk oder bitten Sie einen Mitarbeiter um Hilfe.`,
    MAINTENANCE_KIOSK_UNAVAILABLE_TITLE: `Dieser Kiosk ist derzeit nicht verfügbar`,
    MAINTENANCE_MSR_DISCONNECTED_MESSAGE: `Bitte stellen Sie sicher, dass das Magnetstreifenlesegerät mit dem Kiosk verbunden ist.`,
    MAINTENANCE_MSR_DISCONNECTED_TITLE: `Magnetstreifenlesegerät getrennt`,
    MAINTENANCE_NETWORK_DISCONNECTED_MESSAGE: `Bitte stellen Sie sicher, dass der Kiosk mit dem Netzwerk verbunden ist.`,
    MAINTENANCE_NETWORK_DISCONNECTED_TITLE: `Keine Netzwerkverbindung`,
    MAINTENANCE_NETWORK_UNSTABLE_MESSAGE: `Dieser Kiosk hat Verbindungsprobleme aufgrund einer langsamen Internetgeschwindigkeit. Bitte überprüfen Sie, ob Ihre Verbindung stabil ist. Empfohlene Geschwindigkeit: mindestens 10 Mbps Upload und Download.`,
    MAINTENANCE_NETWORK_UNSTABLE_TITLE: `Instabiles Netzwerk erkannt`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_MESSAGE: `Bitte stellen Sie sicher, dass das Zahlungsgerät eingeschaltet und mit dem Kiosk verbunden ist.`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_TITLE: `Zahlungsgerät getrennt`,
    MAINTENANCE_PRINTER_COVER_OPEN_MESSAGE: `Bitte stellen Sie sicher, dass die Druckerabdeckung geschlossen ist.`,
    MAINTENANCE_PRINTER_COVER_OPEN_TITLE: `Druckerabdeckung offen`,
    MAINTENANCE_PRINTER_DISCONNECTED_MESSAGE: `Bitte stellen Sie sicher, dass der Drucker mit dem Kiosk verbunden ist.`,
    MAINTENANCE_PRINTER_DISCONNECTED_TITLE: `Drucker getrennt`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_MESSAGE: `Bitte stellen Sie sicher, dass der Drucker Papier hat.`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_TITLE: `Drucker ohne Papier`,
    MAINTENANCE_SCALE_DISCONNECTED_MESSAGE: `Bitte stellen Sie sicher, dass die Waage mit dem Kiosk verbunden ist.`,
    MAINTENANCE_SCALE_DISCONNECTED_TITLE: `Waage getrennt`,
    MAINTENANCE_SCANNER_DISCONNECTED_MESSAGE: `Bitte stellen Sie sicher, dass der Scanner mit dem Kiosk verbunden ist.`,
    MAINTENANCE_SCANNER_DISCONNECTED_TITLE: `Scanner getrennt`,
    MAX_ALCOHOLIC_ITEM_LIMIT_REACHED: `Das maximale Limit für alkoholische Getränke pro Bestellung beträgt {{$1: number}}`,
    MAX_SPECIAL_ITEM_LIMIT_REACHED: `Das maximale Limit für Sonderangebote pro Bestellung beträgt {{$1: number}}`,
    MENU_COVER_DINING_OPTIONS: `Wie möchten Sie bestellen?`,
    MENU_COVER_LANGUAGE_OPTIONS: `Sprache auswählen, um zu beginnen`,
    MENU_COVER_PROMO_ALT_TEXT_ITEM: `Hier tippen, um die Bestellung zu starten und diesen beworbenen Artikel anzusehen: {{$1: item name}}!`,
    MENU_COVER_PROMO_ALT_TEXT_SECTION: `Hier tippen, um die Bestellung zu starten und direkt zu diesem beworbenen Bereich zu gelangen: {{$1: section name}}!`,
    MENU_COVER_PROMO_ALT_TEXT_PAGE: `Hier tippen, um die Bestellung zu starten und direkt zu dieser beworbenen Seite zu gelangen: {{$1: page name}}!`,
    MENU_COVER_DINING_OPTION_ALT_TEXT: `Hier tippen, um die Bestellung für „{{$1: fulfillment method}}" zu starten!`,
    MENU_COVER_BACK_TO_DINING_OPTIONS: `Zurück zu den Essensoptionen`,
    MENU_COVER_BACK_TO_PHONE_NUMBER: `Zurück zur Telefonnummer`,
    MARKETING_CONSENT: `Ich möchte Neuigkeiten, Updates, Rabatte und Angebote erhalten`,
    MENU_FILTERS_DIETARY_FILTERS: `Ernährungsoptionen`,
    MENU_FILTERS_DIETARY_FILTERS_DESCRIPTION: `Für eine gesündere Option wählen Sie eine dieser Optionen, um nur diese im Menü anzuzeigen.`,
    MENU_FILTERS_NUTRITION_PREFERENCE: `Ernährungspräferenzen`,
    MENU_FILTERS_OTHER_FILTERS: `Sonstiges`,
    MENU_FILTERS_OTHER_FILTERS_DESCRIPTION: ``,
    MENU_FILTERS_RESTRICTIVE_FILTERS: `Einschränkend`,
    MENU_FILTERS_RESTRICTIVE_FILTERS_DESCRIPTION: `Wenn Sie bestimmte Unverträglichkeiten haben, wählen Sie eine davon, um diese im Menü auszublenden.`,
    MENU_FILTERS_COUNT: `{{$1: number}} Ernährungspräferenzen aktiv. Tippen zum Bearbeiten.`,
    MOD_86D: `Hallo, es scheint ein Problem beim Senden Ihrer Bestellung an die Küche zu geben, da ein Artikel nicht vorrätig ist. Bitte wenden Sie sich an einen Mitarbeiter für Hilfe. Bitte beachten Sie, dass Ihre Zahlung vom Restaurant angenommen WURDE.`,
    MOD_GROUP_AGGREGATE_QUANTITY: `{{$1: number range, e.g. 2-3}} Artikel insgesamt`,
    MOD_GROUP_CHOICES_INCREMENT: `Vielfache von {{$1: number, e.g. you have to get 2/4/6 sauces}}`,
    MOD_GROUP_CHOICES_MAKE_ONE: `treffen Sie eine einzige Auswahl`,
    MOD_GROUP_CHOICES_MAKE_X: `treffen Sie {{$1: number range, e.g. 2-3}} verschiedene Auswahlen`,
    MOD_GROUP_CHOICES_QUANTITY_PER: `{{$1: number range, e.g. 2-3}} pro Auswahl`,
    MOD_GROUP_CHOOSE_AT_LEAST_X: `Mindestens {{$1: number}} wählen`,
    MOD_GROUP_CHOOSE_BETWEEN_X_AND_Y: `Zwischen {{$1: number}} und {{$2: number}} wählen`,
    MOD_GROUP_CHOOSE_ONE: `Eins wählen`,
    MOD_GROUP_CHOOSE_UP_TO_ONE: `Bis zu eins wählen`,
    MOD_GROUP_CHOOSE_UP_TO_X: `Bis zu {{$1: number}} wählen`,
    MOD_GROUP_CHOOSE_X: `{{$1: number}} wählen`,
    MOD_GROUP_DEEMPHASIZE_SHOW: `Anzeigen – {{$1: mod_group}}`,
    MOD_GROUP_DEEMPHASIZE_HIDE: `Ausblenden – {{$1: mod_group}}`,
    MOD_GROUP_WALLET_$_TO_SPEND: ``,
    MOD_GROUP_WALLET_ADDITIONAL_CHOICES_AT_$_PER: ``,
    MOD_GROUP_WALLET_FIRST_X_FREE: `Die ersten {{$1: number}} sind kostenlos.`,
    MOD_GROUP_WALLET_FIRST_SINGLE_FREE: `Der erste ist kostenlos.`,
    MOD_GROUP_WALLET_UP_TO_X: `Bis zu {{$1: number}} zu {{$2: dollar amount}} pro Auswahl`,
    MOD_GROUP_SUBSTITUTION_MOD_CANCEL: `Ersatz schließen`,
    MOD_GROUP_SUBSTITUTION_MOD_CHANGE: `Ersatz ändern`,
    MOD_GROUP_SUBSTITUTION_MOD_SELECT: `Ersetzen`,
    MOD_GROUP_SUBSTITUTION_UNSELECTED: `Zum Artikel hinzufügen`,
    MOD_RECOMMENDED_BADGE: `Empfohlen`,
    MOD_UPSELL_PROMPT_TITLE: `Option hinzufügen?`,
    MOD_UPSELL_PROMPT_ACCEPT: `Hinzufügen`,
    MOD_UPSELL_PROMPT_DECLINE: `Nein, danke`,
    MODIFY: `Ändern`,
    MODIFY_INGREDIENTS: `Zutaten ändern`,
    MORE: `mehr`,
    NAME_CALLED_ORDER_READY: `Ihr Name wird aufgerufen, wenn Ihre Bestellung fertig ist.`,
    NAME_ON_CARD: `Name auf der Karte`,
    NEED_MORE_TIME: `Brauchen Sie mehr Zeit?`,
    NEW_PASSWORD: `Neues Passwort`,
    NEXT: `Weiter`,
    NO: `Nein`,
    NO_ITEMS_MATCH_FILTERS: `Keine Artikel entsprechen Ihren Filtern.`,
    NO_ORDERS_MATCH: `Keine Bestellungen entsprechen Ihrer Suche.`,
    NO_THANKS: `Nein, danke`,
    NO_TIP: `Kein Trinkgeld`,
    NOT_A_MEMBER: `Noch kein Mitglied?`,
    NUTRITION_INFO_CALORIES: `Kalorien`,
    NUTRITION_INFO_PROTEIN: `Eiweiß`,
    NUTRITION_INFO_FAT: `Fett`,
    NUTRITION_INFO_CARBS: `Kohlenhydrate`,
    NUTRITION_INFO_SUGAR: `Zucker`,
    OK: `OK`,
    OR: `oder`,
    OPT_OUT_OF_RECOMMENDATIONS: `Empfehlungen ablehnen`,
    ORDER_GET_ERROR: `Entschuldigung, beim Erstellen Ihrer Bestellung sind Probleme aufgetreten. Bitte versuchen Sie es erneut.`,
    ORDER_HISTORY: `Bestellverlauf`,
    ORDER_HISTORY_EMPTY: `Keine Bestellungen in Ihrem Verlauf. Sobald Sie eine Bestellung aufgeben, wird sie hier angezeigt.`,
    ORDER_HISTORY_ERROR: `Entschuldigung, beim Laden Ihres Bestellverlaufs sind Probleme aufgetreten. Bitte versuchen Sie es erneut.`,
    ORDER_SENT: `Bestellung gesendet`,
    ORDER_SUMMARY: `Bestellübersicht`,
    ORDER_SUMMARY_WITH_NAME: `Bestellübersicht für {{$1 guest name}}`,
    ORDER_SUMMARY_LABEL: `Bestellübersicht. {{$1 fulfillment}} Bestellung`,
    ORDER_SUMMARY_LABEL_WITH_NAME: `Bestellübersicht. {{$1 fulfillment}} Bestellung für {{$2 guest name}}`,
    ORDER_SUMMARY_LABEL_WITH_TABLE: `Bestellübersicht. {{$1 fulfillment}} Bestellung für Tisch {{$2: table number}}`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER: `Bestellübersicht. {{$1 fulfillment}} Bestellung für Tracker #{{$2: tracker number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TABLE: `Bestellübersicht. {{$1 fulfillment}} Bestellung für {{$2 guest name}} an Tisch {{$3: table number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TRACKER: `Bestellübersicht. {{$1 fulfillment}} Bestellung für {{$2 guest name}} für Tracker #{{$3: tracker number}}`,
    ORDER_SUMMARY_LABEL_WITH_ORDER_NUMBER: `Bestellübersicht. {{$1 fulfillment}} Bestellung für Bestellung #{{$2: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER_AND_ORDER_NUMBER: `Bestellübersicht. {{$1 fulfillment}} Bestellung für Tracker #{{$2: tracker number}} für Bestellung #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_TABLE_AND_ORDER_NUMBER: `Bestellübersicht. {{$1 fulfillment}} Bestellung für Tisch {{$2: table number}} für Bestellung #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_ORDER_NUMBER: `Bestellübersicht. {{$1 fulfillment}} Bestellung für {{$2 guest name}} für Bestellung #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TABLE_AND_ORDER_NUMBER: `Bestellübersicht. {{$1 fulfillment}} Bestellung für {{$2 guest name}} an Tisch {{$3: table number}} für Bestellung #{{$4: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TRACKER_AND_ORDER_NUMBER: `Bestellübersicht. {{$1 fulfillment}} Bestellung für {{$2 guest name}} an Tracker {{$3: tracker number}} für Bestellung #{{$4: order number}}`,
    ORDER_THROTTLE_MAX_EXCEEDED: `Entschuldigung! Das Restaurant erhält mehr Bestellungen als es bearbeiten kann. Bitte versuchen Sie es mit einem anderen Zeitslot.`,
    ORDER_TIME_ASAP: `So schnell wie möglich bestellen`,
    ORDER_TIME_LATER: `Später heute`,
    ORDER_TIME_NEXT_BUSINESS_DAY: `Nächster Werktag`,
    ORDER_TIME_FUTURE: `Für später bestellen`,
    ORDER_TOTAL_MAX_EXCEEDED: `Für Großbestellungen wenden Sie sich bitte an einen Mitarbeiter.`,
    ORDER_UPDATE_FAILED: `Bestellaktualisierung fehlgeschlagen.`,
    ORDER_VALIDATION_IN_PROGRESS: `Ihre Bestellung wird validiert`,
    ORDER_VALIDATION_FAILED: `Hoppla! Ein Fehler ist aufgetreten.`,
    ORDER_WAS_PLACED: `Ihre Bestellung wurde aufgegeben.`,
    ORDERING_MODE_CHANGED: `Bestellmodus geändert. Ihre Sitzung wurde zurückgesetzt.`,
    ORDERED_ITEM_MAKE_IT_A_COMBO_LABEL: `Hier tippen, um {{$1: ordered item name}} zu einem Menü zu machen.`,
    ORDERED_ITEM_COMBO_LABEL: `Menü`,
    ORDERING_ITEM_ABSENCE_RESET: `Dieser Artikel war nicht mehr aktuell. Der Artikel wurde in seinen Ausgangszustand zurückgesetzt. Bitte versuchen Sie es erneut.`,
    OUR_MENU: `Unsere Speisekarte`,
    OUTPOST_PICKUP: `Abholung am Außenposten`,
    OUTPOST_ROOM_NUMBER_INSTRUCTION: `Zimmernummer des Außenpostens eingeben`,
    OUTPOST_ROOM_NUMBER_TITLE: `Zimmernummer`,
    OUT_OF_STOCK: `Nicht vorrätig`,
    PAGE_NAVIGATION_TITLE: `Tippen Sie unten auf eine der Optionen, um zu einer bestimmten Seite im Menü zu gelangen. {{$1: total}} Seiten verfügbar.`,
    PARTIAL_PAYMENT_LINE: `Teilzahlung`,
    PARTIAL_PAYMENT_WARNING_TITLE: `Teilzahlung`,
    PARTIAL_PAYMENT_WARNING_MESSAGE: `Für diese Bestellung liegt eine Teilzahlung vor. Wenn Sie zurückgehen möchten, wird Ihre Zahlung zuerst erstattet.`,
    PASSWORD: `Passwort`,
    PASSWORD_REQUIREMENTS: ``,
    PASSWORD_UPDATED: ``,
    PASSWORD_UPDATED_LOG_IN_AGAIN: ``,
    PARTIAL_TENDER_TIMEOUT: `Wenn Sie die Zahlung nicht innerhalb der nächsten 5 Minuten abschließen, werden wir die Bestellung stornieren und Ihre Zahlung erstatten.`,
    PAY_AT_CASHIER: `Bitte gehen Sie zur Kasse zum Bezahlen.`,
    PAY_NOW: `Jetzt bezahlen`,
    PAY_WITH: `Bezahlen mit`,
    PAY_WITH_CREDIT: `Mit Kreditkarte bezahlen`,
    PAY_WITH_DEBIT_CREDIT: `Mit Debit/Kredit bezahlen`,
    PAYMENT: `Zahlung`,
    PAYMENT_DETAILS: `Zahlungsdetails`,
    PAYMENT_LINE_LABEL_DONATION: `Spende über {{$1: amount}}`,
    PAYMENT_LINE_LABEL_SUBTOTAL: `Zwischensumme beträgt {{$1: amount}}`,
    PAYMENT_LINE_LABEL_PARTIAL: `Teilzahlung über {{$1: amount}}`,
    PAYMENT_LINE_LABEL_GIFT_CARD: `Geschenkkarten-Einlösung von {{$1: name}} über {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COUPON: `Coupon-Rabatt von {{$1: name}} über {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COMP_CARD: `Coupon-Rabatt von {{$1: name}} über {{$2: amount}}`,
    PAYMENT_LINE_LABEL_EBT: `EBT-Zahlung über {{$1: amount}}`,
    PAYMENT_LINE_LABEL_LOYALTY: `Treueprogramm-Einlösung von {{$1: name}} über {{$2: amount}}`,
    PAYMENT_LINE_LABEL_REWARD: `Prämien-Einlösung von {{$1: name}} über {{$2: amount}}`,
    PAYMENT_LINE_LABEL_DISCOUNT: `Rabatt von {{$1: name}} über {{$2: amount}}`,
    PAYMENT_LINE_LABEL_TAX: `Steuer beträgt {{$1: amount}}`,
    PAYMENT_LINE_LABEL_TIP: `Trinkgeld beträgt {{$1: amount}}`,
    PAYMENT_LINE_LABEL_SERVICE_CHARGE: `Servicegebühr von {{$1: amount}}`,
    PAYMENT_LINE_LABEL_NAMED_SERVICE_CHARGE: `Servicegebühr von {{$1: amount}} für {{$2: name}}`,
    PAYMENT_LINE_LABEL_TOTAL: `Gesamtbetrag beträgt {{$1: amount}}`,
    PAYMENT_LINE_LABEL_REMAINING: `Restbetrag beträgt {{$1: amount}}`,
    PAYMENT_LINE_LABEL_PAID: `Bezahlter Betrag beträgt {{$1: amount}}`,
    PAYMENT_OPTION_LABEL_CASH: `Tippen, um mit Bargeld zu bezahlen`,
    PAYMENT_OPTION_LABEL_CARD: `Tippen, um mit einer Kreditkarte zu bezahlen`,
    PAYMENT_OPTION_LABEL_COUPON: `Tippen, um einen Coupon einzulösen`,
    PAYMENT_OPTION_LABEL_COMP_CARD: `Tippen, um eine Kompensationskarte einzulösen`,
    PAYMENT_OPTION_LABEL_DONATION: `Tippen, um Spenden zu tätigen oder zu bearbeiten`,
    PAYMENT_OPTION_LABEL_EBT: `Tippen, um mit EBT zu bezahlen`,
    PAYMENT_OPTION_LABEL_EBT_REFUND: `Tippen, um EBT zu erstatten`,
    PAYMENT_OPTION_LABEL_EBT_CASH_BENEFIT: `Tippen, um mit EBT-Bargeldleistung zu bezahlen`,
    PAYMENT_OPTION_LABEL_EBT_FOOD_STAMPS: `Tippen, um mit EBT-Lebensmittelmarken zu bezahlen`,
    PAYMENT_OPTION_LABEL_GIFT_CARD: `Tippen, um mit einer Geschenkkarte zu bezahlen`,
    PAYMENT_OPTION_LABEL_LOYALTY: `Tippen, um Prämien einzulösen`,
    PAYMENT_OPTION_LABEL_LOYALTY_PAYMENT: `Tippen, um Prämien einzulösen`,
    PAYMENT_OPTION_LABEL_FULLY_PAID: `Tippen, um die Zahlung abzuschließen`,
    PAYMENT_PROMPT_NFC: `Bezahlen Sie am Lesegerät, indem Sie Ihre Karte einstecken oder Ihr Handy annähern.`,
    PAYMENT_PROMPT_DIP: `Bezahlen Sie am Lesegerät, indem Sie Ihre Karte einstecken.`,
    PAYMENT_SUCCESSFUL: `Zahlung erfolgreich`,
    PAYMENT_SUCCESSFUL_SUBTITLE: ``,
    PAYMENT_KIOSK_ERROR: `Entschuldigung, Ihre Zahlung ist fehlgeschlagen. Bitte versuchen Sie es erneut.`,
    PAYMENT_KIOSK_TIMEOUT: `Entschuldigung, die Zahlungssitzung ist abgelaufen. Bitte versuchen Sie es erneut.`,
    PAYMENT_TOTAL: `Zahlungsbetrag`,
    PAYMENT_WAS_TAKEN: `Bitte beachten Sie, dass Ihre Zahlung verarbeitet wurde.`,
    PAYMENT_WAS_NOT_TAKEN: `Bitte beachten Sie, dass Ihre Zahlung nicht verarbeitet wurde. Dies ist keine Zahlungsbestätigung.`,
    PHONE_NUMBER: `Telefonnummer`,
    PICK_UP: `Abholung`,
    PICK_UP_AT: `Abholung bei`,
    PICK_UP_ENTER_NUMBER: `Bitte nehmen Sie eine Nummer und geben Sie diese unten ein:`,
    PICK_UP_ENTER_NUMBER_WITH_NAME: `Hallo {{$1: guest name}}, bitte nehmen Sie eine Nummer und geben Sie diese unten ein:`,
    PICK_UP_ENTER_NUMBER_TRACKER: `Bitte nehmen Sie einen Tracker und geben Sie dessen Nummer ein:`,
    PICK_UP_ENTER_NUMBER_TRACKER_WITH_NAME: `Hallo {{$1: guest name}}, bitte nehmen Sie einen Tracker und geben Sie dessen Nummer ein:`,
    PLACE_ORDER: `Bestellung aufgeben`,
    PLEASE_ENTER_A_VALID_AMOUNT: `Bitte geben Sie einen gültigen Erstattungsbetrag ein.`,
    PLEASE_USE_TEST_CARD: `Dieser Standort befindet sich noch im Testmodus. Bitte verwenden Sie eine Testkarte zum Bezahlen.`,
    PLEASE_WAIT: `Bitte warten...`,
    PRICE: `Preis beträgt {{$1:price}}`,
    PRINTING_RECEIPT: `Quittung wird gedruckt...`,
    PRINT_RECEIPT: `Quittung drucken`,
    PRINT_RECEIPT_ERROR: `Entschuldigung, beim Drucken Ihrer Quittung ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.`,
    PRINTED_RECEIPT_COMMAND: `Bitte vergessen Sie nicht, Ihre Quittung mitzunehmen!`,
    PROCESSING_PAYMENT: `Zahlung wird verarbeitet...`,
    PROMOTED_MODIFIER: `Beworben!`,
    QUANTITY_SELECT: `{{$1:quantity}} ausgewählt`,
    QUANTITY_SELECT_INCREASE: `Menge erhöhen`,
    QUANTITY_SELECT_DECREASE: `Menge verringern`,
    QUANTITY_SELECT_LABEL: ``,
    QUIT: `Beenden`,
    QUICK_CHECKOUT: `Schnellkasse`,
    QUICK_NAV_TAP_TO_VIEW: `Tippen zum Ansehen:`,
    QUIZ_RESULTS_TITLE: `Ergebnisse`,
    QUIZ_RESULTS_EMPTY: `Keine Ergebnisse gefunden. Versuchen Sie es erneut mit anderen Antworten.`,
    QUIZ_RESULTS_CAROUSEL_NEXT_LABEL: `Tippen, um das nächste Ergebnis anzusehen. {{$1:index}} von {{$2:total}}`,
    QUIZ_RESULTS_CAROUSEL_PREV_LABEL: `Tippen, um das vorherige Ergebnis anzusehen. {{$1:index}} von {{$2:total}}`,
    QUIZ_STEP_ERROR: `Bitte beantworten Sie alle Fragen, bevor Sie fortfahren.`,
    QUIZ_STEP_ANSWER_LABEL: `Tippen, um mit {{$1:badge name}} zu antworten:`,
    QR_CODE_RECEIPT_INSTRUCTIONS: `Scannen Sie den QR-Code, um eine Kopie Ihrer Quittung auf Ihrem Telefon zu erhalten.`,
    RECEIPT_AUTHORIZATION: `Autorisierung`,
    RECEIPT_CARD_NUMBER: `Kartennr.`,
    RECEIPT_CHECK_ID: `AUSWEIS PRÜFEN`,
    RECEIPT_DISCOUNTS: `Rabatte`,
    RECEIPT_DONATION: `Spende`,
    RECEIPT_FAILED: `Es scheint ein Problem beim Senden Ihrer Bestellung an die Küche zu geben. Bitte wenden Sie sich an einen Mitarbeiter.`,
    RECEIPT_FAILED_ITEM_86D: `Hallo, es scheint ein Problem beim Senden Ihrer Bestellung an die Küche zu geben, da ein Artikel nicht vorrätig ist. Bitte wenden Sie sich an einen Mitarbeiter für Hilfe.`,
    RECEIPT_LOYALTY_POINTS_EARNED_TEXT: ``,
    RECEIPT_MENU_ITEMS_WITHOUT_BARCODE: `Die folgenden Artikel wurden nicht in den QR-Code aufgenommen, da ihnen keine PLU zugeordnet ist:`,
    RECEIPT_NOT_RECEIPT: `Dies ist keine Quittung oder Kaufbestätigung.`,
    RECEIPT_ORDER: `BESTELLUNG`,
    RECEIPT_ORDER_TOTAL: `Bestellsumme`,
    RECEIPT_PAY_AT_CASHIER: `BITTE AN DER KASSE BEZAHLEN`,
    RECEIPT_PICK_UP_AT_LABEL: `Abholung bei`,
    RECEIPT_PICKUP_TIME_LABEL: `Abholzeit`,
    RECEIPT_DELIVERY_TIME_LABEL: `Lieferzeit`,
    RECEIPT_PRINTED: `Quittung gedruckt`,
    RECEIPT_REFUNDED: `Erstattet`,
    RECEIPT_REMAINING_BALANCE: `Restguthaben`,
    RECEIPT_SELF_SERVE: `Selbstbedienung:`,
    RECEIPT_SPECIAL_REQUEST: `Sonderwunsch`,
    RECEIPT_SUB_TOTAL: `Zwischensumme`,
    RECEIPT_TAX_TOTAL: `Steuern gesamt`,
    RECEIPT_TIP_THANKS: `Trinkgeld (Danke!)`,
    RECEIPT_SERVICE_CHARGE: `Servicegebühr`,
    RECEIPT_TRANS_NO: `KIOSK-TRANSAKTIONSNR.`,
    RECEIPT_YOUR_CHECK_NUMBER: `Ihre Bonnummer ist`,
    RECOMMENDATIONS: `Empfehlungen`,
    RECOMMENDED_FOR_YOU: `Für Sie empfohlen`,
    REFUND: `Erstattung`,
    REFUNDER_ALREADY_REFUNDED: `Erstattet`,
    REFUNDER_DELAY_MESSAGE: `Erstattungen können einige Tage dauern, bis sie auf Ihrem Kontoauszug erscheinen.`,
    REFUNDER_INSTRUCTIONS: `Suchen Sie nach Bestellungen mithilfe der Autorisierungsnummer auf der Quittung, der Bestellnummer, der E-Mail-Adresse, der Telefonnummer, der letzten vier Ziffern der Karte, der Transaktionsreferenznummer oder der Bestell-ID.`,
    REFUNDER_SEARCH_PLACEHOLDER: `Autorisierungsnummer der Quittung, Bestellnummer oder letzte vier Ziffern der Karte`,
    REFUNDER_TITLE: `Bestellung erstatten`,
    REFUNDER_SEARCHING_TITLE: `Wird gesucht`,
    REFUNDER_RESULTS_TITLE: `Bestellungen`,
    REFUNDER_RESULTS_EMPTY: `Keine Bestellungen gefunden. Bitte überprüfen Sie Ihre Suchkriterien und versuchen Sie es erneut.`,
    REFUNDER_REFUNDING_TITLE: `Erstattung wird verarbeitet`,
    REFUNDER_REFUND_ERROR: `Beim Verarbeiten Ihrer Erstattung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an den Support.`,
    REFUNDER_REFUND_SUCCESS: `Erstattung erfolgreich! Die Transaktion wird in Kürze verarbeitet.`,
    REFUNDER_REFUND_SUCCESS_BACK: `Erneut suchen`,
    REFUNDER_SEARCH_INPUT_ERROR: `Bitte geben Sie eine gültige Autorisierungsnummer, Bestellnummer oder die letzten vier Ziffern der Karte ein.`,
    REFUNDER_SEARCH_ERROR: `Bei der Suche nach Ihrer Bestellung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an den Support.`,
    REFUNDING: `Erstattung wird verarbeitet...`,
    REFUND_FAILED: `Die Erstattung ist fehlgeschlagen. Bitte versuchen Sie es später erneut.`,
    REMOVE: `Entfernen`,
    REMOVE_CARD: `Vergessen Sie nicht, Ihre Karte mitzunehmen.`,
    REMOVE_COMP_CARD: `Kompensationskarte entfernen`,
    REMOVE_COUPON: `Coupon entfernen`,
    REMOVE_GIFT_CARD: `Entfernen`,
    REMOVE_TIP: `Trinkgeld entfernen`,
    REMOVING_COUPON: `Coupon wird entfernt...`,
    REORDER: ``,
    REPEAT_PASSWORD: `Passwort wiederholen`,
    RESET: `Zurücksetzen`,
    REWARDS: `Prämien`,
    REWARDS_LOGGED_IN: `Prämien`,
    REWARDS_APPLICABLE_TO_ORDER: `Jetzt auf Ihre Bestellung anwendbar`,
    REWARDS_NOT_APPLICABLE_TO_ORDER: `Noch nicht auf Ihre Bestellung anwendbar`,
    REWARDS_EDIT: `Prämien bearbeiten`,
    REWARDS_BALANCE_POINT_LABEL: `{{$1: number}} Punkte`,
    REWARDS_BALANCE_MEAL_EQUIVALENCY_LABEL: `{{$1: number}} Mahlzeiten`,
    REWARDS_COST_POINT_LABEL: `{{$1: number}} Punkte`,
    SAVE: `Aktualisieren`,
    SAVE_CARD: `Karte für zukünftige Einkäufe im Konto speichern.`,
    SCAN_COUPON_BELOW: `Sie können Coupons mit dem Scanner unten scannen.`,
    SCAN_YOUR_GIFT_CARD: `Geschenkkarte scannen`,
    SEARCH: `Suchen`,
    SEARCH_BEGIN: `Geben Sie unten Ihren Suchbegriff ein, um die Suche zu starten.`,
    SEARCH_EMPTY: `Keine Ergebnisse gefunden. Versuchen Sie einen anderen Suchbegriff.`,
    SEARCH_HINT: `Suchen Sie nach Artikeln anhand einer beliebigen Kombination aus Name oder Beschreibung.`,
    SECRET_MENU_IMAGE_ALT: `Tippen, um das geheime Menü anzusehen`,
    SELECT_DATE: `Datum auswählen`,
    SELF_SERVE: `Selbstbedienung`,
    SEND: `Senden`,
    SEND_LOYALTY_SMS: `SMS senden`,
    SEND_ORDER_UI_TIMEOUT: `Hallo, wir versuchen weiterhin, Ihre Bestellung an die Küche zu senden. Bitte wenden Sie sich an einen Mitarbeiter für Hilfe.`,
    SENT_LOYALTY_SIGNUP_SMS: `SMS wurde gesendet! Überprüfen Sie Ihr Telefon und registrieren Sie sich, wann es Ihnen passt.`,
    SENDING_ORDER_KITCHEN: `Bestellung wird an die Küche gesendet...`,
    SENDING_ORDER_VALIDATION: `Bestellung wird bestätigt...`,
    SENDING_RECEIPT: `Quittung wird gesendet...`,
    SENDING_SMS: `SMS wird gesendet...`,
    SERVICE_CHARGE: `Servicegebühr`,
    SHOW: `Anzeigen`,
    SHOW_NUTRITION: `Nährwertinformationen anzeigen`,
    SHOW_STAFF_FIRST: `Bitte zeigen Sie diese Nachricht einem Mitarbeiter, bevor Sie beenden.\nWirklich beenden?`,
    SIGNUP_CTA: `Registrieren Sie sich für ein Konto!`,
    SIGN_OUT: `Abmelden`,
    SIGN_UP: `Registrieren`,
    SIGNUP_BENEFITS: `Erstellen Sie ein Konto, um Ihre Kreditkarte und Lieblingsartikel für einen schnelleren Checkout zu speichern.`,
    SIGNUP_LOYALTY: `Beim Treueprogramm registrieren`,
    SKIP: `Überspringen`,
    SPECIAL_REQUESTS: `Sonderwünsche`,
    SPECIAL_REQUESTS_EXAMPLE: `z. B.: Soße separat, ohne Sardellen, usw.`,
    SPECIAL_REQUESTS_FINEPRINT: `Ersetzungen und Sonderwünsche können zusätzliche Kosten verursachen.`,
    SPECIAL_REQUESTS_ADD: `Sonderwunsch hinzufügen`,
    SPECIAL_REQUESTS_ERROR_TOO_LONG: `Der Sonderwunsch ist zu lang.`,
    SPECIAL_REQUESTS_ERROR_NO_INVALID_CHARACTERS: `Bitte verwenden Sie nur Buchstaben, Zahlen und Satzzeichen.`,
    SPECIAL_REQUESTS_ERROR_NO_VALUE: `Bitte geben Sie einen Sonderwunsch ein.`,
    SR_REMOVE_ITEM_FROM_CART: `Artikel aus dem Warenkorb entfernen.`,
    STARTING_ORDER: `Bestellung wird gestartet...`,
    UPDATING_ORDER: `Bestellung wird aktualisiert...`,
    START_ORDER_BY_SCANNING: `Starten Sie Ihre Bestellung, indem Sie einen Artikel unten am Kiosk scannen.`,
    START_NEW_ORDER: `Weitere Bestellung aufgeben`,
    STORED_VALUE_REMAINING_BALANCE: `verbleibend`,
    STORE_INFO: ``,
    STORE_INFORMATION: `Restaurantinformationen`,
    STUDENT_CARD: `Studentenausweis`,
    STUDENT_CARD_INSUFFICIENT_FUNDS: `Entschuldigung, dieser Studentenausweis hat nicht genug Guthaben.`,
    STUDENT_CARD_SUBTITLE_HID: `Studentenausweis antippen zum Bezahlen`,
    STUDENT_CARD_SUBTITLE_HID_MSR: `Studentenausweis antippen oder durchziehen zum Bezahlen`,
    STUDENT_CARD_SUBTITLE_MSR: `Studentenausweis durchziehen zum Bezahlen`,
    SUBMIT: `Absenden`,
    SUBTOTAL: `Zwischensumme`,
    SUBTOTAL_REDUCED: `Reduzierte Zwischensumme`,
    SUBTOTAL_INCREASED: `Neue Zwischensumme`,
    SUBTOTAL_WARNING_COMBO_SAVE_TITLE: `Sie sparen mit einem Menü!`,
    SUBTOTAL_WARNING_COMBO_SAVE_LINE: `Sie sparen`,
    SUCCESS: `Erfolg`,
    SUMMARY_STEP_FOOTNOTE: ``,
    SUMMARY_STEP_NOTICE: ``,
    SWITCH_LOCATION: `Standort wechseln`,
    SWITCH_TO_CATERING: `Zum Catering wechseln`,
    SWITCH_TO_WEB: `Zur Online-Bestellung wechseln`,
    SWIPE_YOUR_GIFT_CARD: `Geschenkkarte zum Bezahlen durchziehen`,
    SWIPE_YOUR_COMP_CARD: `Kompensationskarte zum Bezahlen durchziehen`,
    SWIPE_OR_SCAN_YOUR_GIFT_CARD: `Geschenkkarte zum Bezahlen durchziehen oder scannen`,
    TAKING_LONGER_THAN_USUAL: `Dauert länger als üblich...`,
    TAP_HERE_FOR_LANGUAGE: `Hier tippen für {{$1: language}}`,
    TAP_OUTSIDE_CLOSE: `Außerhalb tippen zum Schließen`,
    TAP_TO_REDEEM: `Tippen zum Einlösen`,
    TAXES: `Steuern`,
    TERMS_OF_SERVICE: `Nutzungsbedingungen`,
    TERMS_OF_SERVICE_LOAD_FAILED: `Fehler beim Laden der Nutzungsbedingungen`,
    TEXT_RECEIPT: `Quittung per SMS`,
    TEXT_RECEIPT_SEND_FAILED: `Quittung per SMS konnte nicht gesendet werden.`,
    TEXT_RECEIPT_SEND_SUCCESS: `Quittung gesendet!`,
    TEXT_YOU_WHEN_READY: `Wir senden Ihnen eine SMS, wenn Ihre Bestellung fertig ist.`,
    THANK_YOU: `Danke!`,
    THEN_PRESS_BUTTON_1: `Drücken Sie dann die`,
    THEN_PRESS_BUTTON_2: `Taste.`,
    TIP: `Trinkgeld`,
    TIPPING: `Trinkgeld wird hinzugefügt...`,
    TIP_AMOUNT_TOO_HIGH: `Der Trinkgeldbetrag ist zu hoch.`,
    TIP_AMOUNT_TOO_LOW: `Der Trinkgeldbetrag ist zu niedrig.`,
    TIP_FAILED: `Entschuldigung! Trinkgeld konnte nicht hinzugefügt werden. Bitte versuchen Sie es erneut.`,
    TIP_CANNOT_BE_MODIFIED: `Entschuldigung! Sie können Ihr Trinkgeld nicht mehr ändern, nachdem Sie die Bestellung bezahlt haben.`,
    TIP_LABEL_PERCENT: `Tippen, um {{$1: percent}}% ({{$2: amount}}) Trinkgeld hinzuzufügen`,
    TIP_LABEL_FIXED: `Tippen, um {{$1: amount}} Trinkgeld hinzuzufügen`,
    TIP_LABEL_CUSTOM: `Tippen, um ein benutzerdefiniertes Trinkgeld hinzuzufügen`,
    TIP_LABEL_NONE: `Tippen, um das Trinkgeld zu entfernen`,
    TO_GO: `Zum Mitnehmen`,
    TOTAL: `Gesamt`,
    TOTAL_CHANGED_SUBTOTAL_TEXT: `Die Preise einiger Artikel in Ihrer Bestellung haben sich geändert.`,
    TOTAL_CHANGED_SUBTOTAL_LEADING_TEXT: `Die Zwischensumme hat sich geändert und beträgt jetzt`,
    TOTAL_CHANGED_LEADING_TEXT: `Der Gesamtbetrag hat sich geändert und beträgt jetzt`,
    TOTAL_CHANGED_TRAILING_TEXT: `. Möchten Sie mit der Bestellung fortfahren?`,
    TOTAL_PAID: `Gezahlter Betrag`,
    TOTAL_REMAINING: `Restbetrag`,
    TOTAL_SUBSCRIPT: ``,
    TRY_AGAIN: `Erneut versuchen`,
    UNABLE_TO_FETCH_LOCATION_EXPLANATION: `Es scheint, dass wir Ihren Standort nicht ermitteln konnten. Bitte geben Sie Ihre Adresse ein.`,
    UNAVAILABLE_ITEM: `Entschuldigung, dieser Artikel ist nicht mehr verfügbar.`,
    UNIT_GRAM: `{{$1: amount}}g`,
    UNIT_NUTRITION_INFO_CALORIES: `{{$1: amount}} Kalorien`,
    UNIT_NUTRITION_INFO_PROTEIN: `{{$1: amount}} Eiweiß`,
    UNIT_NUTRITION_INFO_CARBS: `{{$1: amount}} Kohlenhydrate`,
    UNIT_NUTRITION_INFO_FAT: `{{$1: amount}} Fett`,
    UNIT_NUTRITION_INFO_SUGAR: `{{$1: amount}} Zucker`,
    UP_TO_X: `bis zu {{$1: number}}`,
    USE_COMP_CARD: `Kompensationskarte verwenden`,
    USE_COUPON: `Coupon verwenden`,
    USE_EBT_CARD: `EBT-Karte`,
    USE_EBT_CASH_BENEFIT: `EBT-Bargeldleistung`,
    USE_EBT_FOOD_STAMP: `EBT-Lebensmittelmarken`,
    USE_GIFT_CARD: `Geschenkkarte verwenden`,
    USERNAME: `Benutzername`,
    VALIDATION_MESSAGE_EMAIL_IS_INVALID: `Die E-Mail-Adresse ist ungültig`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED: `{{$1: field name, e.g. 'email'}} ist erforderlich`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED_GENERIC: `Dieses Feld ist erforderlich`,
    VALIDATION_MESSAGE_ONLY_LETTERS_AND_NUMBERS: `Bitte verwenden Sie nur Buchstaben und Zahlen`,
    VALIDATION_MESSAGE_ONLY_LETTERS_NUMBERS_AND_SPECIAL_CHARS: `Bitte verwenden Sie nur Buchstaben, Zahlen, &, # oder .`,
    VALIDATION_MESSAGE_PASSWORD_REQUIREMENTS: `Das Passwort muss mindestens 1 Ziffer, 1 Großbuchstaben und 1 Kleinbuchstaben enthalten und mindestens 14 Zeichen lang sein.`,
    VALIDATION_MESSAGE_PHONE_NUMBER_IS_INVALID: `Die Telefonnummer ist ungültig`,
    VALIDATION_MESSAGE_POSTAL_CODE_IS_INVALID: `Die Postleitzahl muss numerisch sein`,
    VENDOR_UNAVAILABLE_MESSAGE: `Dieser Anbieter ist derzeit geschlossen. Bitte überprüfen Sie die Öffnungszeiten und kommen Sie zu einem anderen Zeitpunkt wieder.`,
    VEHICLE_COLOR: `Fahrzeugfarbe`,
    VEHICLE_MAKE: `Fahrzeugmarke`,
    VEHICLE_MODEL: `Fahrzeugmodell`,
    VERIFY_ACCOUNT: `Konto verifizieren`,
    VERIFY_ACCOUNT_CTA: `Verifizieren Sie Ihr Konto, um mit der Bestellung zu beginnen.`,
    VIDEO_LOAD_FAILED: `Video konnte nicht geladen werden`,
    VIEW: `Anzeigen`,
    WE_APOLOGIZE: `Wir entschuldigen uns für die Unannehmlichkeiten.`,
    WEIGHING_INSTRUCTIONS: `Bitte legen Sie Ihren Artikel auf die Waage`,
    WELCOME_BACK: `Willkommen zurück! Für Sie ausgewählte Artikel:`,
    WELCOME_BACK_WITH_NAME: `Willkommen zurück, {{$1: guest name}}! Für Sie ausgewählte Artikel:`,
    WELCOME_TO: `Willkommen bei {{$1: org name}}!`,
    WELCOME_TO_NO_NAME: ``,
    WHEN_WOULD_YOU_LIKE_YOUR_ORDER: `Abholzeit wählen`,
    WHICH_OUTPOST_FOR_YOUR_ORDER: `Wo möchten Sie Ihre Bestellung abholen?`,
    YES: `Ja`,
    YOU_PREVIOUSLY_ORDERED: `Sie haben bereits bestellt`,
    YOUR_CURRENT_LOCATION: `Ihr aktueller Standort`,
    YOUR_NAME: `Ihr Name`,
    YOUR_ORDER: `Ihre Bestellung`,
    YOUR_SUBTOTAL: `Ihre Zwischensumme`,
    ZOOM_TOGGLE_ON: `Tippen, um Zwei-Finger-Zoom zu aktivieren`,
    ZOOM_TOGGLE_OFF: `Tippen, um Zwei-Finger-Zoom zu deaktivieren`,
    ZOOM_INSTRUCTIONS: `Zwei-Finger-Zoom ist aktiviert. Verwenden Sie zwei Finger zum Vergrößern und Verkleinern.`,
    STARBUCKS_COVER_1_BUTTON: `Ich weiß, was ich möchte`,
    STARBUCKS_COVER_2_BUTTON: `Zeigen Sie es mir`,
    STARBUCKS_COVER_2_TITLE: `Erlebnisse, Verkostungen, Wissen`,
    STARBUCKS_COVER_PROMO_A: `Kaffee-Finder`,
    STARBUCKS_COVER_PROMO_B: `Starbucks Rewards`,
    STARBUCKS_EXPERIENCES_TITLE: `Erlebnisse`,
    STARBUCKS_EXPERIENCES_SUBTITLE: `Tauchen Sie in die Handwerkskunst, das Theater und die Innovation des Kaffees ein, wenn Sie ein Signature-Erlebnis buchen`,
    STARBUCKS_EXPERIENCES_RESERVE_NOW: `Für heute reservieren`,
    STARBUCKS_EXPERIENCES_RESERVE_LATER: `Für später reservieren`,
    STARBUCKS_EXPERIENCES_BACK: `Zurück zu den Erlebnissen`,
    STARBUCKS_WAYFINDER_CARD_EXPERIENCE_BUTTON: `Mehr erfahren`,
    STARBUCKS_WAYFINDER_CARD_MENU_BUTTON: `Zum Menü`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL_FIND: `Wo bin ich?`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL: `Sie sind hier`,
    STARBUCKS_WAYFINDER_BATHROOMS_LABEL: `Toiletten`,
    STARBUCKS_WAYFINDER_OPEN_SEATING_LABEL: `Freie Sitzplätze`,
    STARBUCKS_WAYFINDER_HOTSPOTS_LABEL: `Einen Ort finden`,
    STARBUCKS_WAYFINDER_DIRECTIONS_TITLE: `Ziehen Sie mit dem Finger, um den Raum zu erkunden.`,
    STARBUCKS_WAYFINDER_DIRECTIONS_SUBTITLE: `Tippen Sie auf einen hervorgehobenen Ort, um mehr darüber zu erfahren.`,
    STARBUCKS_COFFEE_FINDER_QUESTION_1_TITLE: `Abenteuerlust`,
    STARBUCKS_COFFEE_FINDER_QUESTION_1_SUBTITLE: `Wie abenteuerlich mögen Sie Ihren Kaffee?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_2_TITLE: `Bevorzugte Aromen`,
    STARBUCKS_COFFEE_FINDER_QUESTION_2_SUBTITLE: `Wenn Sie an Ihren Kaffee denken, welche Aromen klingen für Sie am köstlichsten?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_3_TITLE: `Stärke`,
    STARBUCKS_COFFEE_FINDER_QUESTION_3_SUBTITLE: `Wie stark genießen Sie Ihren Kaffee?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_4_TITLE: `Bevorzugte Kaffeebestellung`,
    STARBUCKS_COFFEE_FINDER_QUESTION_4_SUBTITLE: `Wie bestellen Sie Ihren Kaffee normalerweise?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_EDIT: `Tippen zum Bearbeiten`,
    STARBUCKS_COFFEE_FINDER_QUESTION_CONFIRM: `Bestätigen Sie Ihre Auswahl`,
    STARBUCKS_COFFEE_FINDER_QUESTION_RESTART: `Von vorne beginnen`,
    STARBUCKS_COFFEE_FINDER_ANSWER_TITLE: `Es sieht so aus, als würden Sie Folgendes genießen:`,
    STARBUCKS_COFFEE_FINDER_ANSWER_SUBTITLE: `Kaufen Sie nur die Bohnen, oder wir empfehlen das untenstehende Getränk mit dieser Bohne:`,
    STARBUCKS_COFFEE_FINDER_ANSWER_GO_TO_MENU: `Vollständiges Menü ansehen`,
    STARBUCKS_COFFEE_FINDER_ANSWER_RESTART: `Von vorne beginnen`,
    STARBUCKS_VIEW_WAYFINDER: `Zeigen Sie es mir`,
    STARBUCKS_VIEW_COFFEE_FINDER: `Meine Optionen eingrenzen`,
    STARBUCKS_VIEW_EXPERIENCES: `Erlebnisse ansehen`,
    'cover.session.timeout': `Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.`,
    'cover.reduced-height.button': `Bestellung beginnen`,
    'cover.loyalty.title': `Willkommen`,
    'cover.five-guys.documents': ``,
    'cover.five-guys.allergen-nutrition': ``,
    'cover.five-guys.ingredients': ``,
    'cover.five-guys.storm-document-instructions': ``,
    'cover.loyalty.login': `Mit Treueprogramm anmelden`,
    'cover.loyalty.guest': `Als Gast fortfahren`,
    'guest-identifier.button.quit': `Beenden`,
    'guest-identifier.button.skip': `Überspringen`,
    'guest-identifier.button.back': `Zurück`,
    'guest-identifier.button.next': `Weiter`,
    'guest-identifier.button.submit.cover': `Weiter`,
    'guest-identifier.button.submit.edit': `Weiter`,
    'guest-identifier.button.submit.checkout': `Weiter`,
    'guest-identifier.phone.tos.button-back': `Zurück`,
    'guest-identifier.phone.tos.title': `Nutzungsbedingungen`,
    'guest-identifier.phone.tos.link': `Nutzungsbedingungen für Telefonnummer`,
    'guest-identifier.phone.title': ``,
    'guest-identifier.table.instructions.table-number': ``,
    'guest-identifier.table.instructions.tracker-number': ``,
    'guest-identifier.name.loyalty-title': `Mit Ihrem Treuekonto anmelden`,
    'guest-identifier.name.loyalty-button': `Mit Treueprogramm anmelden`,
    'guest-identifier.name.loyalty-separator': `oder`,
    'guest-identifier.name.loyalty-error-title': `Hoppla! Name nicht gefunden`,
    'guest-identifier.name.loyalty-error-description': `Leider konnte kein Name für dieses Konto gefunden werden. Bitte geben Sie Ihren Namen unten ein`,
    'inactivity-timer.button.continue': `Ja, ich brauche mehr Zeit`,
    'inactivity-timer.button.exit': `Nein, ich bin fertig`,
    'item-card.add.with-quantity': `Hinzufügen ({{$1: quantity}})`,
    'image.scan.default.alt': `Scannen Sie Ihren Barcode oder QR-Code`,
    'loyalty.view_coupons': `Coupons anzeigen`,
    'loyalty.add_coupons': `Coupons hinzufügen`,
    'loyalty.label.manual_redemption': `Einlösecode`,
    'loyalty.label.manual_redemption_instructions': `Geben Sie Ihren Einlösecode ein, um Ihre Prämie zu nutzen`,
    'loyalty.label.welcome.new-user': `Hallo, {{$1: user}}! Sie haben jetzt ein Treuekonto`,
    'loyalty.reward_label.payment_unapplied': `Zahlung auf gespeicherte Karte anwenden`,
    'loyalty.reward_label.redeemable_unredeemed': `Mit {{$1: points}} Punkten einlösen`,
    'loyalty.reward_label.payment_at_checkout': `Zahlung kann beim Checkout angewendet werden`,
    'loyalty.reward_group_label.payment': `Zahlungsprämien`,
    'loyalty.rewards.payment-reward.name': `Mit Guthaben bezahlen`,
    'loyalty.rewards.payment-reward.name-with-amount': `Mit Guthaben bezahlen ({{$1: amount}})`,
    'loyalty.rewards.payment-reward.description': `Ihr aktuelles Guthaben`,
    'loyalty.rewards.card-on-file-payment.description': `Die Zahlung wird von Ihrer gespeicherten Karte abgebucht.`,
    'loyalty.redemption_auth.back_to_rewards': `Zurück zu den Prämien`,
    'loyalty.redemption_auth.subtitle': `Scannen Sie Ihren Einlöse-Barcode, um Ihre Prämie zu nutzen`,
    'loyalty.redemption_auth.submit': `Prämie einlösen`,
    'loyalty.signup.header': ``,
    'loyalty.signup.email-already-exists': ``,
    'loyalty.signup.email-and-sms-consent': ``,
    'loyalty.signup.enter-your-email-address': ``,
    'loyalty.signup.enter-your-name': `Namen eingeben`,
    'loyalty.signup.enter-your-phone-number': `(555) 555-5555`,
    'loyalty.signup.consent-required': `Bitte akzeptieren Sie die Geschäftsbedingungen, um fortzufahren.`,
    'loyalty.checkout-signup.header': `Letzte Chance, sich zu registrieren und Prämien für diese Bestellung zu sammeln!`,
    'loyalty.checkout-signup.skip': `Überspringen und zur Kasse`,
    'loyalty.checkout-signup.success.new-account.title': `Neues Konto erstellt`,
    'loyalty.checkout-signup.success.new-account.description': `Danke, dass Sie dabei sind. Sie sammeln Prämien für diese Bestellung!`,
    'loyalty.checkout-signup.success.existing-account.title': `Konto bereits vorhanden`,
    'loyalty.checkout-signup.success.existing-account.description': `Sie haben sich bereits mit dieser Nummer registriert. Sie sind jetzt angemeldet.`,
    'loyalty.checkout-signup.error.title': `Fehler beim Erstellen des Kontos`,
    'loyalty.checkout-signup.error.description': `Beim Erstellen des Kontos ist ein Problem aufgetreten`,
    'loyalty.checkout-signup.error.skip': `Überspringen und zur Kasse`,
    'loyalty.checkout-signup.error.try-again': `Erneut versuchen`,
    'menu.item.reset': `Artikel zurücksetzen`,
    'menu.mod-group.quick-select': `Schnellauswahl`,
    'menu.mod-group.quick-select-active': `Ausgewählt`,
    'menu.mod-group.quick-select-clear': ``,
    'menu.page.scanner.initial.title': `Artikel scannen, um mit der Bestellung zu beginnen`,
    'menu.page.scanner.scanned.title': `Artikel im Warenkorb`,
    'menu.scanned-item-added-dialog.button.go-to-scanner-page': `Gescannte Artikel ansehen`,
    'order-history.button.add-to-order': `Verfügbare Artikel hinzufügen ({{$1: number}})`,
    'order-history.title': `Bestellverlauf`,
    'order-history.subtitle': `Alle Ihre bisherigen Bestellungen werden hier angezeigt. Interagieren Sie mit den Artikeln, um sie anzusehen oder zu Ihrer aktuellen Bestellung hinzuzufügen. Sie können alle Artikel einer Bestellung mit einem einzigen Tippen hinzufügen.`,
    'order-history.next-page': `Weiter`,
    'order-history.previous-page': `Zurück`,
    'order-history.screen.close': `Schließen`,
    'order-history.screen.error.title': `Ein Fehler ist aufgetreten`,
    'order-history.screen.error.subtitle': `Bestellverlauf konnte nicht geladen werden. Bitte versuchen Sie es später erneut.`,
    'order-history.screen.error.button.back': `Zurück`,
    'order-history.screen.error.button.retry': `Erneut versuchen`,
    'order-history.screen.no-orders': `Keine früheren Bestellungen gefunden. Sobald Sie eine Bestellung aufgegeben haben, können Sie sie hier einsehen.`,
    'order-history.screen.order-has-quick-add-uneligible-items': `Einige Artikel in dieser Bestellung sind nicht für die schnelle Nachbestellung verfügbar. Bitte fügen Sie die Artikel hinzu, indem Sie sie einzeln antippen.`,
    'order-history.section.button.view-all': `Mehr meiner Bestellungen anzeigen`,
    'order-history.topbar.button.back': `Zurück`,
    'loyalty.unapplicable_rewards_warning_title': `Nicht anwendbare Prämien`,
    'loyalty.unapplicable_rewards_warning_description': `Um die ausgewählte Prämie einzulösen, fügen Sie die entsprechenden Artikel zu Ihrem Warenkorb hinzu. Die Prämie und der Rabatt werden beim Bezahlen angewendet.`,
    'loyalty.unapplicable_rewards_warning_confirm': `Anwenden`,
    'loyalty.discard_reward_changes.title': ``,
    'loyalty.discard_reward_changes.description': ``,
    'loyalty.discard_reward_changes.keep_editing': ``,
    'loyalty.discard_reward_changes.discard': ``,
    'loyalty.rewards.terms_button_label': ``,
    'loyalty.rewards.terms_dialog.apply': ``,
    'loyalty.rewards.terms_dialog.remove': ``,
    'loyalty.rewards.terms_dialog.back': ``,
    'loyalty.reward_ineligible.title': ``,
    'loyalty.reward_ineligible.title_generic': ``,
    'loyalty.reward_ineligible.title_plural': ``,
    'loyalty.reward_ineligible.description': ``,
    'loyalty.reward_ineligible.description_plural': ``,
    'loyalty.reward_ineligible.back_to_menu': ``,
    'loyalty.reward_ineligible.continue': ``,
    'loyalty.reward_ineligible.continue_plural': ``,
    'loyalty.auth_method.manual_redemption': `Manuelle Eingabe`,
    'loyalty.button.menu.authed': `Prämien`,
    'loyalty.button.menu.unauthed': `Prämien`,
    'loyalty.button.checkout.authed': `Prämien`,
    'loyalty.button.checkout.unauthed': `Prämien`,
    'loyalty.error.reward_failed_to_apply': `Prämie konnte nicht angewendet werden. Bitte versuchen Sie es erneut.`,
    'loyalty.login.pin.label': ``,
    'loyalty.login.pin.error-required': ``,
    'loyalty.login-options.button.skip.menu': `Überspringen und zum Menü fortfahren`,
    'loyalty.login-options.button.skip.checkout': `Überspringen und zur Zahlung fortfahren`,
    'loyalty.login-options.button.skip.dining-option-collection': `Überspringen und mit dem Bezahlen fortfahren`,
    'loyalty.login-options.title': `Anmeldeoption wählen oder als Gast fortfahren`,
    'loyalty.login-options.subtitle': `Sie können sich jederzeit später anmelden`,
    'loyalty.login-options.signup.link': `Noch kein Konto? Registrieren`,
    'loyalty.login-options.barcode.title': `Barcode scannen`,
    'loyalty.login-options.barcode.subtitle': `Scannen Sie Ihren Barcode zum Anmelden`,
    'loyalty.login-options.email-phone-number.title': `E-Mail und Telefonnummer`,
    'loyalty.login-options.email-phone-number.subtitle': `Geben Sie Ihre E-Mail und Telefonnummer ein, um sich anzumelden`,
    'loyalty.login-options.email-password.title': `E-Mail und Passwort`,
    'loyalty.login-options.email-password.subtitle': `Geben Sie Ihre E-Mail und Ihr Passwort ein, um sich anzumelden`,
    'loyalty.login-options.username-password.title': `Benutzername und Passwort`,
    'loyalty.login-options.username-password.subtitle': `Geben Sie Ihren Benutzernamen und Ihr Passwort ein, um sich anzumelden`,
    'loyalty.login-options.phone-number.placeholder': `(555) 555-5555`,
    'loyalty.login-options.phone-number.title': `Telefonnummer`,
    'loyalty.login-options.phone-number.subtitle': `Geben Sie Ihre Telefonnummer ein, um sich anzumelden`,
    'loyalty.login-options.card-number.title': `Kartennummer`,
    'loyalty.login-options.card-number.subtitle': `Geben Sie Ihre Kartennummer ein, um sich anzumelden`,
    'loyalty.login-options.email.title': `E-Mail`,
    'loyalty.login-options.email.subtitle': `Geben Sie Ihre E-Mail ein, um sich anzumelden`,
    'loyalty.login-options.or': `ODER`,
    'loyalty.login-options.popup.close': `Schließen`,
    'loyalty.error.or': `ODER`,
    'loyalty.login-error.saved-form': `Ihre übermittelten Informationen:`,
    'loyalty.login-error.try-again.button': `Erneut versuchen`,
    'loyalty.otp.enter-code.title': `Geben Sie den Code ein, den wir Ihnen gesendet haben`,
    'loyalty.otp.sent-to.email': `Wir haben einen Code per E-Mail an {{$1: masked email}} gesendet`,
    'loyalty.otp.sent-to.sms': `Wir haben einen Code per SMS an {{$1: masked phone number}} gesendet`,
    'loyalty.otp.verify': `Bestätigen`,
    'loyalty.otp.resend': `Code erneut senden`,
    'loyalty.otp.code.error.invalid': `Dieser Code ist falsch. Bitte versuchen Sie es erneut.`,
    'loyalty.otp.send-error.message': `Wir konnten kein eindeutiges Konto mit diesen Informationen finden. Bitte überprüfen Sie sie und versuchen Sie es erneut.`,
    'loyalty.login.fallback.phone-number.button': `Telefonnummer verwenden`,
    'loyalty.login.fallback.barcode.button': `Barcode oder QR-Code scannen`,
    'loyalty.login.fallback.card-number.button': `Kartennummer verwenden`,
    'loyalty.login.fallback.email.button': `E-Mail verwenden`,
    'loyalty.login.fallback.email-phone-number.button': `E-Mail und Telefonnummer verwenden`,
    'loyalty.login.fallback.email-password.button': `E-Mail und Passwort verwenden`,
    'loyalty.login.fallback.username-password.button': `Benutzername und Passwort verwenden`,
    'loyalty.login.auth-method.phone-number.title': `Telefonnummer`,
    'loyalty.login.auth-method.barcode.title': `Barcode oder QR-Code scannen`,
    'loyalty.login.auth-method.card-number.title': `Kartennummer`,
    'loyalty.login.auth-method.email.title': `E-Mail`,
    'loyalty.login.auth-method.email-phone-number.title': `E-Mail und Telefonnummer`,
    'loyalty.login.auth-method.email-password.title': `E-Mail und Passwort`,
    'loyalty.login.auth-method.username-password.title': `Benutzername und Passwort`,
    'vitrine.error.order_validation_failed': `Bestellung konnte nicht validiert werden. Bitte versuchen Sie es erneut.`,
    'vitrine.error.handshake_failed': `Verbindung zum Kiosk konnte nicht hergestellt werden. Bitte wenden Sie sich an einen Mitarbeiter.`,
    'vitrine.error.request_timeout': `Anfrage konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.`,
    'vitrine.error.request_aborted': `Anfrage konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.`,
    'vitrine.error.analytics_send_error': `Analysedaten konnten nicht gesendet werden. Bitte versuchen Sie es erneut.`,
    'vitrine.error.garcon_incompatible_build': `Verbindung zum Kiosk konnte nicht hergestellt werden. Bitte wenden Sie sich an einen Mitarbeiter für Hilfe.`,
    'vitrine.error.loyalty-login-no-matching-user-title': `Ihr Konto wurde nicht gefunden`,
    'vitrine.error.loyalty-login-no-matching-user-message': `Es wurde kein Benutzer mit den angegebenen Informationen gefunden.`,
    'vitrine.error.loyalty_not_enough_points': `Ihr Konto hat nicht genug Punkte, um die ausgewählten Prämien einzulösen.`,
    'vitrine.error.order_total_above_max': `Die Bestellsumme hat das zulässige Maximum überschritten. Bitte wenden Sie sich an einen Mitarbeiter.`,
    'vitrine.error.empty_menu': `Das ausgewählte Menü ist derzeit leer. Bitte versuchen Sie eine andere Essensoption.`,
    'maitred.error.integration_bad_config': `Es scheint ein Problem mit der Kiosk-Konfiguration zu geben. Bitte wenden Sie sich an einen Mitarbeiter.`,
    'checkout.done.expo_receipt.error': `Quittung konnte nicht gedruckt werden. Bitte versuchen Sie es erneut.`,
    'checkout.done.expo_receipt.success': `Quittung gesendet! Bitte bitten Sie ein Teammitglied um Hilfe.`,
    'checkout.done.print-receipt.out-of-paper': `Der Drucker hat kein Papier mehr. Bitte wenden Sie sich für Ihre Quittung an einen Mitarbeiter.`,
    'refunder.viewing-results.button.cancel': `Abbrechen`,
    'refunder.viewing-results.button.refund-all': `Alles erstatten`,
    'refunder.viewing-results.button.view-transaction': `Transaktionen ansehen`,
    'refunder.viewing-results.button.done': `Fertig`,
    'refunder.viewing-results.button.back': `Zurück`,
    'refunder.viewing-results.button.search': `Bestellung suchen`,
    'refunder.viewing-results.refund-order.error-print-receipt': `Die Bestellung wurde erfolgreich erstattet, aber die Quittung konnte nicht gedruckt werden. Bitte versuchen Sie erneut zu drucken.`,
    'refunder.viewing-results.refund-order.success': `Bestellung erfolgreich erstattet.`,
    'refunder.viewing-results.refund-order.error': `Erstattung der Bestellung fehlgeschlagen. Bitte versuchen Sie es erneut.`,
    'refunder.viewing-results.order.refunded': `Bestellung erstattet`,
    'refunder.viewing-results.order.total': `Bestellsumme`,
    'refunder.search-form.button.back': `Zurück`,
    'refunder.search-form.button.search': `Suchen`,
    'refunder.viewing-order.title': `Alle Transaktionen für Bestellung #{{$1: order number}}`,
    'refunder.viewing-order.subtitle': `Bitte wählen Sie die Transaktion aus, die Sie erstatten möchten.`,
    'refunder.viewing-order.button.cancel': `Abbrechen`,
    'refunder.viewing-order.button.refund': `Erstatten`,
    'refunder.viewing-order.button.refund-partial': `Teilerstattung`,
    'refunder.viewing-order.button.retry': `Erneut versuchen`,
    'refunder.viewing-order.button.done': `Fertig`,
    'refunder.viewing-order.button.back': `Zurück`,
    'refunder.viewing-order.refund-transaction.error': `Die Transaktion konnte nicht erstattet werden. Bitte versuchen Sie es erneut.`,
    'refunder.viewing-order.refund-transaction.success': `Transaktion erfolgreich erstattet.`,
    'refunder.viewing-order.refund-transaction.error-print-receipt': `Die Transaktion wurde erfolgreich erstattet, aber die Quittung konnte nicht gedruckt werden. Bitte versuchen Sie erneut zu drucken.`,
    'refunder.viewing-order.transaction.total': `Gesamt`,
    'refunder.viewing-order.transaction.refunded': `Erstattet`,
    'refunder.viewing-order.error.title': `Fehler`,
    'refunder.viewing-order.error.message': `Bestellung konnte nicht geladen werden. Bitte versuchen Sie es erneut.`,
    'refunder.viewing-order.error.button.retry': `Erneut versuchen`,
    'refunder.viewing-order.error.button.back': `Zurück`,
    'refunder.partial-transaction-refund.error.amount-too-high': `Der Betrag ist zu hoch.`,
    'refunder.partial-transaction-refund.error.amount-too-low': `Der Betrag ist zu niedrig.`,
    'refunder.partial-transaction-refund.error.amount-invalid': `Der Betrag ist ungültig.`,
    'refunder.partial-transaction-refund.error.amount-required': `Der Betrag ist erforderlich.`,
    'refunder.partial-transaction-refund.error': `Bei der Verarbeitung der Erstattung ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.`,
    'refunder.partial-transaction-refund.button.submit': `Teilerstattung absenden`,
    'refunder.partial-transaction-refund.button.back': `Zurück`,
    'refunder.partial-transaction-refund.title': `Teilerstattung der Transaktion`,
    'refunder.partial-transaction-refund.hint': `Bitte geben Sie den Betrag ein, den Sie erstatten möchten. Der Höchstbetrag beträgt {{$1: amount}}`,
    'refunder.partial-transaction-refund.label': `Betrag`,
    'refunder.partial-transaction-refund.placeholder': `0.00`,
    'checkout.cart.alcohol-verification.age-requirement': `21+`,
    'checkout.cart.alcohol-requires-food.notice': ``,
    'checkout.cart.alcohol-requires-food.title': ``,
    'checkout.cart.alcohol-requires-food.description': ``,
    'checkout.cart.group-ordering.actions.change-recipient': `Empfänger bearbeiten`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.title': `Artikel zuweisen an`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.cancel': `Abbrechen`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.add-new': `Neu hinzufügen`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.reassign': `Neu zuweisen`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.who-is-this-for': `Für wen ist dieser Artikel?`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.assign-to-guest': `Diesem Gast zuweisen`,
    'checkout.cart.starbucks-stars': `{{$1: amount}} ★ Artikel`,
    'checkout.cart.mod-group-heading': `{{$1: mod group name}}:`,
    'checkout.cart.upsize.title': ``,
    'checkout.cart.upsize.label': ``,
    'menu.nav.starbucks.menu': `Hauptmenü`,
    'menu.nav.starbucks.experiences': `Erlebnisse`,
    'menu.nav.starbucks.wayfinder': `Wegweiser`,
    'menu.secret-menu.access-code.title': `Zugangscode eingeben`,
    'menu.secret-menu.access-code.button.back': `Zurück`,
    'menu.secret-menu.access-code.button.submit': `Absenden`,
    'menu.secret-menu.access-code.error': `Ungültiger Zugangscode`,
    'menu.secret-menu.access-code.success': `Zugangscode akzeptiert`,
    'menu.toast.added-to-cart': `Zum Warenkorb hinzugefügt`,
    'menu.toast.combo-savings': `Menü-Ersparnis!`,
    'menu.toast.discount-applied': `Rabatt angewendet!`,
    'menu.exit-verification.title': `Manager-Verifizierung erforderlich`,
    'menu.exit-verification.description': `Zum Beenden wird ein Mitarbeiterzugangscode benötigt. Bitte bitten Sie ein Teammitglied um Hilfe.`,
    'menu-item.starbucks-stars': `{{$1: amount}} ★`,
    'menu-item.product-information.title': ``,
    'menu-item.product-information.open': ``,
    'menu-item.product-information.tab.product-info': ``,
    'menu-item.product-information.tab.nutrition': ``,
    'menu-item.product-information.tab.allergens': ``,
    'menu-item.product-information.nutrition.option': ``,
    'menu-item.product-information.empty': ``,
    'menu-item.scale.title': `Bitte legen Sie Ihren Artikel auf die Waage.`,
    'menu-item.scale.weight': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.weighs': `Wiegt`,
    'menu-item.scale.price-per-unit': `{{$1: price}} pro {{$2: unit}}`,
    'menu-item.scale.price': `Preis`,
    'menu-item.scale.instructions': `Wiegen Sie Ihren Artikel mit der Waage. Zum Zurücksetzen drücken Sie den auf der Waage angezeigten Knopf.`,
    'menu-item.scale.weight-per-unit': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.reading-weight': `Wird gewogen...`,
    'menu-item.scale.error-reading-weight': `Fehler beim Lesen des Gewichts. Bitte versuchen Sie es erneut.`,
    'menu-item.scale.error-no-weight': `Bitte wiegen Sie Ihren Artikel, wenn Sie ihn zur Bestellung hinzufügen möchten.`,
    'menu-item.scale.no-scale': `Keine Waage erkannt. Bitte wenden Sie sich an einen Mitarbeiter.`,
    'also-consider.title': `Das könnte Ihnen auch gefallen...`,
    'also-consider.back-to-item': `Zurück zum Artikel`,
    'also-consider.add-to-order': `Zur Bestellung hinzufügen`,
    'also-consider.skip-add-on': `Ergänzung überspringen`,
    'menu-item.assorted.title': `Stellen Sie Ihr Sortiment zusammen`,
    'menu-item.assorted.count': `{{$1: count}} von {{$2: total}} ausgewählt`,
    'menu-item.row-size-mod.option.none': `Keine`,
    'menu-item.upsize.prompt.title': `Möchten Sie eine größere Größe?`,
    'menu-item.upsize.comparison.title': ``,
    'menu-item.upsize.comparison.accept': ``,
    'menu-item.upsize.comparison.speech': ``,
    'menu-item.upsize.comparison.price-difference': ``,
    'menu-item.upsize.prompt.accept': `Ja, {{$1: size name}} nehmen`,
    'menu-item.upsize.prompt.decline': `Nein, danke`,
    'menu-item.upsize.nudge': `Auf {{$1: size name}} ändern`,
    'menu-item.upsize.selection-loss.title': ``,
    'menu-item.upsize.selection-loss.description': ``,
    'menu-item.upsize.selection-loss.confirm': ``,
    'menu-item.upsize.selection-loss.cancel': ``,
    'menu-item.high-sugar-warning.description': `Warnung: Dieses Symbol weist darauf hin, dass der Gehalt an zugesetztem Zucker dieses Artikels dem empfohlenen täglichen Gesamthöchstwert für zugesetzten Zucker bei einer Ernährung mit 2.000 Kalorien (50 g) entspricht oder diesen übersteigt. Der Verzehr großer Mengen an zugesetztem Zucker über einen längeren Zeitraum kann das Risiko für Typ-2-Diabetes, Gewichtszunahme und Karies erhöhen.`,
    'menu-item.high-sodium-warning.description': `Warnung: Dieses Symbol weist darauf hin, dass der Natrium-(Salz-)Gehalt dieses Artikels über dem empfohlenen täglichen Gesamthöchstwert (2.300 mg) liegt. Eine hohe Natriumaufnahme kann den Blutdruck erhöhen und das Risiko für Herzerkrankungen und Schlaganfälle steigern.`,
    'menu-item.group-ordering.items-for': `Gruppenbestellung – Artikel für:`,
    'menu-item.group-ordering.prompt.title': `Als Gruppe bestellen?`,
    'menu-item.group-ordering.prompt.description': `Bei der Gruppenbestellung werden Sie gefragt, welchem Mitglied Ihrer Gruppe jeder Artikel gehört. Tippen Sie auf „Ja“, um die Gruppenbestellung zu aktivieren. Tippen Sie auf „Nein“, wenn Sie mit dieser Option fortfahren möchten.`,
    'menu-item.group-ordering.prompt.button.accept': `Ja, Gruppenbestellung`,
    'menu-item.group-ordering.prompt.button.decline': `Nein, danke`,
    'menu-item.group-ordering.add-recipient': `Neu hinzufügen`,
    'menu-item.group-ordering.add-recipient-name.dialog.title': `Neuen Empfänger hinzufügen`,
    'menu-item.group-ordering.add-recipient-name.dialog.placeholder': `Geben Sie den Namen des Empfängers ein`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.submit': `Dem Gast zuweisen`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.cancel': `Abbrechen`,
    'menu-item.group-ordering.recipient-picker.title': `Für wen ist das?`,
    'menu-item.group-ordering.recipient-picker.add-new': `Neu hinzufügen`,
    'menu-item.nested-mod-groups.edit': `Bearbeiten`,
    'menu-item.nested-mod-groups.popup.done': `Fertig`,
    'menu-item.nested-mod-groups.popup.cancel': `Abbrechen`,
    'menu-item.nested-mod-groups.popup.back': `Zurück`,
    'menu-item.nested-mod-groups.popup.next': `Weiter`,
    'checkout.cart.remove-item-verification.title': `Manager-Verifizierung erforderlich`,
    'checkout.cart.remove-item-verification.description': `Zum Entfernen dieses Artikels aus dem Warenkorb wird ein Mitarbeiterzugangscode benötigt. Bitte bitten Sie ein Teammitglied um Hilfe.`,
    'checkout.cart.confirm-remove-item.title': `Artikel entfernen?`,
    'checkout.cart.confirm-remove-item.description': `Möchten Sie {{$1: item name}} wirklich aus Ihrem Warenkorb entfernen?`,
    'checkout.cart.confirm-remove-item.cancel': `Abbrechen`,
    'checkout.cart.confirm-remove-item.confirm': `Entfernen`,
    'checkout.cart.pre-checkout-recommendations.title': `Bestellung vervollständigen`,
    'checkout.cart.pre-checkout-recommendations.continue-button': `Weiter`,
    'checkout.cart.pre-checkout-recommendations.back-button': `Zurück`,
    'checkout.cart.item-86d.title.items': `Einige Artikel sind nicht mehr verfügbar`,
    'checkout.cart.item-86d.title.mods': `Einige Modifikationen sind nicht mehr verfügbar`,
    'checkout.cart.item-86d.title.mixed': `Einige Artikel und Modifikationen sind nicht mehr verfügbar`,
    'checkout.cart.item-86d.description.items': `Die folgenden Artikel wurden aus Ihrem Warenkorb entfernt:`,
    'checkout.cart.item-86d.description.mods': `Die folgenden Modifikationen wurden von Ihren Artikeln entfernt:`,
    'checkout.cart.item-86d.description.mixed': `Folgendes ist nicht mehr verfügbar und wurde entfernt:`,
    'checkout.cart.item-86d.entity.menu-item': `{{$1: item name}}`,
    'checkout.cart.item-86d.entity.price-option': `{{$1: item name}} — {{$2: price option name}}`,
    'checkout.cart.item-86d.entity.mod': `{{$1: mod name}} (in {{$2: item name}})`,
    'checkout.cart.item-86d.edit-item-button': `Bearbeiten`,
    'checkout.payment-options.tip.invalid-tip-amount': `Es tut uns leid, Sie können kein Trinkgeld anwenden, das höher ist als der Bestellbetrag. Bitte geben Sie einen Trinkgeldbetrag ein, der niedriger ist als die Zwischensumme der Bestellung abzüglich etwaiger Rabatte.`,
    'checkout.payment-options.name.title': `Hallo, {{$1: name}}`,
    'checkout.payment-options.gift-cards.prompt.title': `Wählen Sie eine Geschenkkarten-Methode`,
    'checkout.payment-options.gift-cards.prompt.default-option': `Geschenkkarte`,
    'checkout.payment-options.pay-with-cash-machine.label': `Tippen, um am Bargeldautomaten zu bezahlen`,
    'checkout.payment-options.pay-with-cash-machine.button': `Bargeld`,
    'checkout.payment-options.donation.or': `ODER`,
    'checkout.payment-options.service-charge.info-message': ``,
    'checkout.payment-options.service-charge.info-label': `Informationen zur Servicegebühr`,
    'checkout.payment-options.credit-card.button.zero-balance': `Bestellung aufgeben`,
    'checkout.payment-options.inline-loyalty.view-all': `Alle Prämien anzeigen`,
    'checkout.payment-options.inline-loyalty.apply': `Prämien anwenden`,
    'checkout.payment-options.inline-loyalty.greeting': `Hallo, {{$1: name}}!`,
    'checkout.payment-options.inline-loyalty.star-balance': `Sterne-Guthaben: {{$1: stars}}★`,
    'checkout.payment-options.inline-loyalty.celebration.title': `Alles Gute zum Geburtstag!`,
    'checkout.payment-options.inline-loyalty.celebration.title-with-name': `Alles Gute zum Geburtstag, {{$1: name}}!`,
    'checkout.payment-options.inline-loyalty.celebration.subtitle': `Genießen Sie Ihr Geschenk!`,
    'checkout.payment-options.inline-loyalty.error.title': `Prämien konnten nicht angewendet werden`,
    'checkout.payment-options.inline-loyalty.error.message': `Beim Anwenden Ihrer Prämien ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.`,
    'loyalty.starbucks.header.redeemable-stars': `Einlösbare Sterne`,
    'loyalty.starbucks.header.stars-expiring': `{{$1: stars}}★ verfallen am {{$2: date}}`,
    'loyalty.starbucks.header.stars-no-expiry': `Ihre Sterne verfallen nicht`,
    'loyalty.starbucks.progress.next-status-by-date': `Sammeln Sie {{$1: stars}}★ bis zum {{$2: date}}, um den Status {{$3: level}} zu erreichen`,
    'loyalty.starbucks.progress.next-status': `Sammeln Sie {{$1: stars}}★, um den Status {{$2: level}} zu erreichen`,
    'loyalty.starbucks.progress.maintain-status-by-date': `Sammeln Sie {{$1: stars}}★ bis zum {{$2: date}}, um Ihren Status {{$3: level}} um ein weiteres Jahr zu verlängern`,
    'loyalty.starbucks.progress.maintain-status': `Sammeln Sie {{$1: stars}}★, um Ihren Status {{$2: level}} um ein weiteres Jahr zu verlängern`,
    'loyalty.starbucks.progress.extended': `Um ein weiteres Jahr verlängert`,
    'loyalty.starbucks.progress.annual-earned': `Dieses Jahr gesammelt`,
    'loyalty.starbucks.progress.status-target': `Status {{$1: level}}`,
    'loyalty.starbucks.progress.to-extend': `zum Verlängern`,
    'loyalty.starbucks.birthday.title': `Alles Gute zum Geburtstag, {{$1: name}}!`,
    'loyalty.starbucks.birthday.title-no-name': `Alles Gute zum Geburtstag!`,
    'loyalty.starbucks.birthday.redeem': `Lösen Sie Ihren Geburtstagsgutschein ein!`,
    'loyalty.starbucks.birthday.description': `Genießen Sie ein Lieblingsgetränk oder einen Leckerbissen auf unsere Kosten. Lösen Sie es beim Bezahlen ein oder sagen Sie es Ihrem Barista bei der Bestellung.`,
    'loyalty.starbucks.birthday.valid-until': `Gültig bis {{$1: date}}`,
    'loyalty.starbucks.member-since': `Mitglied seit {{$1: year}}`,
    'loyalty.starbucks.member-since.subtitle': `Vielen Dank, dass Sie ein treues Starbucks Rewards-Mitglied sind.`,
    'checkout.paying.starbucks.title': `Bitte scannen Sie jetzt den QR-Code in Ihrer Starbucks App`,
    'checkout.paying.starbucks.subtitle': `Bitte stellen Sie sicher, dass die Scan to Pay-Funktion in Ihrer Starbucks App bereit ist, um Ihre Bestellung abzuschließen.`,
    'checkout.paying.starbucks.cancel-button': `Abbrechen`,
    'checkout.paying.error.card-not-accepted': ``,
    'checkout.paying.error.loyalty-payment': `Es tut uns leid, wir konnten Ihre Zahlung nicht verarbeiten. Bitte versuchen Sie es erneut.`,
    'checkout.paying.error.pos.print': `Fortfahren und Quittung drucken`,
    'checkout.paying.error.table-tracker.print': `Fortfahren und Quittung drucken`,
    'checkout.paying.error.table-tracker.title': `Hoppla! Wir konnten Ihren Pager nicht abrufen.`,
    'checkout.paying.error.table-tracker.instructions': `Ihre Bestellung wurde ausgeführt, aber beim Ausgeben Ihres Tischtrackers zum Verfolgen Ihrer Bestellung ist ein Fehler aufgetreten. Fahren Sie mit dem nächsten Schritt fort, um Ihre Quittung zu erhalten.`,
    'checkout.paying.error.title': `Hoppla!`,
    'checkout.paying.sending-table-tracker-request.title': `Pager wird ausgegeben`,
    'checkout.paying.sending-table-tracker-request.subtitle': `Bitte warten Sie, während wir Ihren Tischtracker ausgeben.`,
    'checkout.paying.cash-machine.pinging.title': `Bargeldautomat wird überprüft`,
    'checkout.paying.cash-machine.pinging.subtitle': `Bitte warten Sie, während wir prüfen, ob der Bargeldautomat verfügbar ist.`,
    'checkout.paying.cash-machine.awaiting.title': `Bargeldautomat in Benutzung`,
    'checkout.paying.cash-machine.awaiting.subtitle': `Bitte warten Sie, bis der Bargeldautomat verfügbar ist.`,
    'checkout.paying.cash-machine.awaiting.cancel-button': `Abbrechen`,
    'checkout.paying.cash-machine.receiving.title': `Bargeldautomat bereit`,
    'checkout.paying.cash-machine.receiving.subtitle': `Bitte legen Sie Ihre Zahlung in den Bargeldautomaten ein.`,
    'checkout.paying.cash-machine.receiving.cancel-button': `Abbrechen`,
    'checkout.paying.cash-machine.receiving.cancel-refund-button': `Abbrechen und Zahlung erstatten`,
    'checkout.paying.cash-machine.receiving.partial-button': `Den Rest auf andere Weise bezahlen`,
    'checkout.paying.cash-machine.receiving.amount': `{{$1: amount}} verbleibend`,
    'checkout.paying.cash-machine.receiving.take-change-prompt': `Bitte entnehmen Sie alle Scheine und Münzen aus dem Bargeldautomaten.`,
    'checkout.paying.cash-machine.cancelling.title': `Zahlung am Bargeldautomaten wird abgebrochen`,
    'checkout.paying.cash-machine.cancelling.subtitle': `Bitte entnehmen Sie alle Scheine und Münzen aus dem Bargeldautomaten.`,
    'checkout.paying.cash-machine.cancelling.error.title': `Fehler beim Abbrechen der Zahlung am Bargeldautomaten`,
    'checkout.paying.cash-machine.cancelling.error.subtitle': `Ihre Zahlung konnte nicht abgebrochen werden. Bitte bitten Sie einen Mitarbeiter um Hilfe.`,
    'checkout.paying.cash-machine.cancelling.error.print': `Fortfahren und Quittung drucken`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.title': `Unzureichendes Wechselgeld`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.subtitle': `Der Bargeldautomat konnte Ihnen kein Wechselgeld für Ihre Zahlung geben, daher haben wir Ihre Zahlung erstattet.`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.try-again-button': `Erneut versuchen`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.back-button': `Zurück`,
    'checkout.paying.cash-machine.error.message': `Der Bargeldautomat konnte Ihre Zahlung nicht verarbeiten. Bitte versuchen Sie es erneut.`,
    'checkout.done.details.guest-name': `Name`,
    'checkout.done.details.table-number': `Tischnummer`,
    'checkout.done.details.tracker-number': `Trackernummer`,
    'checkout.done.details.order-number': `Bestellnummer`,
    'checkout.done.error.table-tracker.instructions': `Beim Abrufen Ihres Pagers ist ein Fehler aufgetreten. Ihre Bestellung wurde erfolgreich verarbeitet. Bitte bitten Sie einen Mitarbeiter um Hilfe.`,
    'checkout.done.qr-code.error': `Es tut uns leid, wir konnten keinen QR-Code für Ihre Quittung erstellen.`,
    'printer-receipt.stored-value-remaining-balance': `{{$1: label}} Restguthaben`,
    'printer-receipt.order-ready-at': ``,
    'printer-receipt.punchh-barcode-header': ``,
    'printer-receipt.refund-receipt-header': ``,
    'order-reconciler.error.dining-option-unavailable': `Die von Ihnen gewählte Essensoption ist nicht mehr verfügbar. Ihre Bestellung wurde aktualisiert, um „{{$1: dining option name}}“ zu verwenden.`,
    'order-reconciler.error.items-unavailable': `Einige Artikel in Ihrer Bestellung sind nicht mehr verfügbar. Ihre Bestellung wurde aktualisiert, um die nicht verfügbaren Artikel zu entfernen. Die folgenden Artikel wurden entfernt: {{$1: item names}}`,
    'page-nav.order-history-item.title': `Meine Bestellungen`,
    'page-nav.order-history-item.cta': `Meine Bestellungen anzeigen`,
    'print.error.phone-number-label': `Telefonnummer`,
    'print.error.guest-name-label': `Name`,
    'print.error.table-number-label': `Tischnummer`,
    'print.error.tracker-number-label': `Trackernummer`,
    'print.error.order-number-label': `Bestellnummer`,
    'debug.untranslated-locale': `Trinkgeld hinzufügen`,
};
//# sourceMappingURL=strings.de-de.js.map